/**
* jv.candidate.details.workflow.scheduler.controller Module
*
* Description
*/
angular.module('jv.candidate.details.workflow.scheduler.controller', [])
    .controller('jvCandidateDetailsWorkflowSchedulerController',
        ['$scope', '$routeParams', 'candidates', '$location', '$filter', '$rootScope', '$timeout','$log', '$window', 'TextUtil', CandDetailsWorkflowScheduler]);

function CandDetailsWorkflowScheduler($scope, $routeParams, candidates, $location, $filter, $rootScope, $timeout, $log, $window, TextUtil) {

    //custom startDate and endDate for fetching free busy info
    var FREEBUSYSTARTDATE = -3;
    var FREEBUSYENDDATE = 13;

    // $scope.flags.loading = false;
    //assign passed-on parentScope to $scope.$parent to maintain parent-child relationship between controllers
    if(!$.isEmptyObject($rootScope.parentScope)){
        $rootScope.parentScope.reRenderEvents = true;
        angular.extend($scope.$parent, $rootScope.parentScope);
    }
    // checkMode(parent controller) redirects to workflow tab if there is no mode present.
    if($routeParams.mode ==='schedule'){
        $rootScope.mode = 'schedule';
        $rootScope.interviewStatus = 'Schedule';
    }

    if(!$scope.checkMode()){
        return;
    }

    // Holds all location objects fetched from the server.
    $scope.allLocations = {};
    $scope.sortedLocations=[];
    // Eid of the currently selected location, ng-model of the locations dropdown in the left panel.
    $scope.selLocationEId = '';
    $scope.newLocation = {};
    $scope.DEFAULT_INT_HOURS = 2;
    $scope.showEditSchedule = false;

//    $scope.interviewersSelect = candidates.allEmployeeSelect;
    // Object representing the values in popup
    $scope.popUp = {};
    $scope.locationFeatures = {};
    $scope.popUp.addedResources = [];
    $scope.popUp.removedResources = [];
    $scope.popUp.origIntrvrs = {};
    $scope.popUp.origEventId = '';

    // Used to Sync or Revert(respectively) the  changes made to an event object through the popup
    $scope.currEditedEvent = {}; // Holds the dirty inline changes that will be synced on save of popup, discarded on cancel/close.
    $scope.originalEvent = {}; // Event object before the popup was shown - used to revert changes on cancel/close of popup

    $scope.TIME_SLOT = 15;
    $scope.INT_DURATION_MINS = 60;

    // Starting at -1(instead of 0) as the current time bar event is always there
    $scope.total = -1;

    // Indicates if the locations dropdown should be shown in the sidepanel and the popup. Values assigned on startup ajax.
    $scope.showLocations = false;

    $scope.SCHEDULER_NAMESPACE = 'scheduler';
    $scope.FREEBUSY_NAMESPACE = 'freebusy';

    $scope.freebusy = new FreeBusy($scope, candidates, $filter, $rootScope);

    $scope.showGcal = true;
    $scope.selfSchedule= {};

    // Holds stack of XHR calls currently in process, can be used for determining hiding and showing of loading/busy overlay.
    $scope.loading = [];

    $scope.skipNavAway = false;
    $scope.selectedTimezoneObj = {};
    // Private variabless

    $scope.videoConferencingProperties = {};
    $scope.videoConferencingProperties.videoConferenceEnabled = false;
    $scope.videoConferencingProperties.includeConferenceLink = false;

    var initTimezoneChange = true;
    var scheduler;
    var tempLocCount=0;

    var now, later;

    var tz = $window._jvselfUser.locale.timezone;

    //get time in user time zone
    //var localDate = $filter('localeDateTime')(new Date(), 'longTimestamp', 'MMMM dd, yyyy HH:mm:ss');
    var localDate = (moment.tz(new Date(),$window._jvselfUser.locale.timezone));
    now = localDate.toDate();
    // Free Busy declarations

    $scope.allEvents = [];
    $scope.intervColIndex = 0;
    //This will keep tack of location added in Side Pannel
    $scope.pannelResouceloc={};

    //accordian select2
    $scope.newInterviewer = [];
    //select2 service
    $scope.employeeSelect = candidates.employeeSelect;
    /*
     * Setting timeout to let all the functions on calendar finish before it checks the boundaries
     */
    $scope.reRenderCalender = function(val){
        setTimeout(function(){
            $('#calendar').fullCalendar('render');
        },val || 100);
    };

    $scope.locationSelect = function() {
        var config = {
                id : 'EId',
                ajax : {
                    url : '../../action/application/'+$routeParams.applicationId+'/interview/'+$routeParams.stateId+'/schedule',
                    data : function (term, page) {
                        var pageSize = term && 10 || 50;
                        return {
                            q: term,
                            pageSize: pageSize,
                            page: page - 1
                        };
                    },
                    results: function (data) { // parse the results into the format expected by Select2.
                        // since we are using custom formatting functions we do not need to alter remote JSON data
                        var more = Boolean(data.interviewSchedule.length);
                        return {
                            results: data.interviewSchedule.workflowElementInfo.metaModel.interviewLocation,
                            more: more
                        };
                    }
                },
                formatResult: function (data) {
                    return TextUtil.htmlEncode(data.name);
                },
                formatSelection: function (data) {
                    return data.name;
                },
                initSelection: function(element, callback) {
                    var url = config.ajax.url,
                    isMultiple = element.attr('multiple');
                    if (isMultiple) {
                        url += '&ids=' + element.val();
                    } else {
                        url += '&ids=' + element.val().split(',').join('&ids=');
                    }

                    $.ajax({ type: 'GET', url: url, success: function(data){
                        data = config.ajax.results(data).results;
                        if (!isMultiple) {
                            if (data.length) {
                                data = data[0];
                            } else {
                                data = false;
                            }
                        }
                        callback(data);
                    }});
                }
        };
        return config;
    };

    $scope.callbackModal = {};

    $scope.callbackModal.ok = function(){
        var modal = $rootScope.modal;
        var context = modal.context || $rootScope;
        if(modal.okCallback){
            if(angular.isString(modal.okCallback)){
                context[modal.okCallback](modal.okArgs);
            }else{
                modal.okCallback.apply(context, modal.okArgs);
            }
        }
        modal.show = false;
    };

    $scope.callbackModal.cancel = function(){
        var modal = $rootScope.modal;
        var context = modal.context || $rootScope;
        if(modal.cancelCallback){
            if(angular.isString(modal.cancelCallback)){
                context[modal.okCallback](modal.cancelArgs);
            }else{
                modal.cancelCallback.apply(context, modal.cancelArgs);
            }
        }
        modal.show = false;
    };

    $scope.pastModal = {
        show:false,
        buttons: [
            {
              label: i18n.ADD_INTERVIEW,
              title: i18n.ADD_INTERVIEW,
              click:  function(){
                  $scope.$parent.allowPast = true;
                  $scope.callbackModal.ok();
              }
            },
            {
              label: i18n.CANCEL,
              title: i18n.CANCEL,
              click:  $scope.callbackModal.cancel,
              'class': 'cancel'
            }
        ],
        title: i18n.INTERVIEW_IN_PAST_TITLE,
        body: i18n.INTERVIEW_IN_PAST_BODY,
        context : $scope,
        cancel:$scope.callbackModal.cancel
    };

    /**
     * Invoked from both dayClick and select events.
     */
    var showAddPopUp = function(start, end, source, inDigest){
        if($scope.popUp.mode){
            return;
        }

        // Use the method inPast
        if(!$scope.allowPast && $scope.inPast(start)){
            // Best way to circumvent FCs duplicate call of dayCick and select, leading to double alerts.
            if($rootScope.modal.show){
                return;
            }
            $scope.pastModal.okCallback = showAddPopUp;
            $scope.pastModal.okArgs = Array.prototype.slice.call(arguments);
            if(!$scope.pastModal.okArgs){
                $scope.pastModal.okArgs = [];
            }
            $scope.pastModal.okArgs[3] = true;   // inDigest = true, indicating we are inside $apply already.
            $scope.pastModal.show = true;
            $scope.$apply('$root.modal = pastModal');
            return;
        }


        $scope.popUp.mode='add';
        $scope.popUp.interviewers = [];
        $scope.popUp.location = '';
        $scope.popUp.date = angular.copy(start);
        $scope.popUp.startTime = {h:start.getHours(), m:start.getMinutes()};

        // If source has a value, it means it came from fc's select(for now) so it would have the end time information.
        if(source && end.getTime()){
            $scope.popUp.endTime = {h:end.getHours(), m:end.getMinutes() };
        }else{
            $scope.popUp.endTime = {h:start.getHours()+ Math.floor($scope.INT_DURATION_MINS/60), m:start.getMinutes() };
        }
        // If it is crossing into midnight and into the next day, pull it back to 11:59pm(talk to product).
        if( $scope.popUp.endTime.h >= 24){
            $scope.popUp.endTime = {h:23, m: 59};
        }
        $scope.locationFeatures.isOtherPopup = false;
        if(inDigest){
            $scope.popUp.mode='add';
        }else{
            $scope.$apply('popUp.mode="add"');
        }
    };

    var updatePopUpTime = function(event){
        if($scope.popUp.mode){
            $scope.popUp.startTime = {h:event.start.getHours(), m:event.start.getMinutes()};
            $scope.popUp.endTime = {h:event.end.getHours(), m: event.end.getMinutes()};
            $scope.$apply();
        }
    };

    /**
     * Set the date and time of the passed in 'date' object to end(11:59) of the specified day or today.
     */
    var endOfDay = function(date, day){
        day = day || new Date();
        date.setDate(day.getDate());
        date.setHours(23);
        date.setMinutes(59);
    };

    /**
     * If the edit is valid it updates the popup with the new time, otherwise reverts the event to
     * its original position.
     *
     */
    var onEdit = function(event, minuteDelta, revert, inDigest){
        var dirtyEvents;
        var newStart = event.start, oldStart, movedToPast = false;

        // Check only if the event has moved backward. (events moving forward are etiher already validated or not in the past)
        if(minuteDelta < 0){
            oldStart = new Date(newStart.getTime() - (minuteDelta * 60000));
            movedToPast = !$scope.inPast(oldStart) && $scope.inPast(newStart); // If the original event was not in past.
        }

        if(!$scope.allowPast && movedToPast){
            $scope.pastModal.okCallback = onEdit;
            $scope.pastModal.cancelCallback = revert;
            $scope.pastModal.okArgs = Array.prototype.slice.call(arguments);
            if(!$scope.pastModal.okArgs){
                $scope.pastModal.okArgs = [];
            }
            $scope.pastModal.okArgs[3] = true; // inDigest = true, indicating we are inside $apply already.
            $scope.pastModal.show = true;
            $scope.$apply('$root.modal = pastModal');
            return;
        }

        if($scope.popUp.mode){
            updatePopUpTime(event);
        }else if(event.end.getDate() > event.start.getDate()){
            endOfDay(event.end, event.start);
        }
        if(event.interviewers){
            angular.forEach(event.interviewers, function(interviewer){
                $scope.freebusy.replaceEvent(event, interviewer);
            });
        }
        if(event.location){
            $scope.freebusy.replaceEvent(event, {EId: event.location});
        }
        if(event.existing){
            event.dirty = true;
            // calculating the total here, as the render event in the directive is not under the $apply
            dirtyEvents = scheduler.fullCalendar('clientEvents', function(event){
                return !event.existing || event.dirty;
            }).length;
            if(inDigest){
                $scope.total = dirtyEvents;
            }else{
                $scope.$apply('total = dirtyEvents');
            }
        }
    };

//  Refer Fullcalendar's documentation for below methods and variables:
//  http://arshaw.com/fullcalendar/docs/
//Setting format of date shown on the title of the calendar according to use preferences.
    $scope.defaultViewFormat = $window._jvselfUser && $window._jvselfUser.locale && $window._jvselfUser.locale.localizationSupport==='OFF' ? 'dddd, MMM d, yyyy' : 'dddd, '+$window._jvselfUser.locale.userDate.longDate();
    $scope.schOptions = {

            header : {
                left:'title',
                right: 'prev,next'
            },
            timeFormat: false,
            defaultView : 'agendaDay',
            droppable : true,
            slotMinutes : $scope.TIME_SLOT,
            allDaySlot: false,
            firstHour : 10,
            selectable : true,
            unselectAuto : false,
            editable : true,
            contentHeight : 722,
            defaultEventMinutes : $scope.INT_DURATION_MINS,
            snapMinutes : 15,
            columnFormat : {
                day:''
            },
            titleFormat: {
                month: 'MMMM yyyy',
                week: "MMM d[ yyyy]{ '&#8212;'[ MMM] d yyyy}",
                day: $scope.defaultViewFormat
            },
            select : function(start, end){
                if(!$scope.popUp.mode){
                    showAddPopUp(start, end, 'select');
                }
                scheduler.fullCalendar('unselect');
            },

            viewDisplay : function(){
                // actions
            },

            eventDragStop : function(){
                // actions
            },

            eventDrop : function(event, dayDelta, minuteDelta, allDay, revert){
                onEdit(event, minuteDelta, revert);
            },

            eventResize : function(event, dayDelta, minuteDelta, revert){
                onEdit(event, minuteDelta, revert);
            },

            unselect : function(){
                // actions
            },

            drop : function(date, allDay, jsEvent, ui, dayView, inDigest ){
                var interviewerId, locationEId, event, filteredEvents = [];
                interviewerId = $(this).data('interviewer');
                locationEId = $(this).data('location');

                filteredEvents = scheduler.fullCalendar('clientEvents', function(clientEvent){
                    var endDate = new Date(date.getTime()+($scope.INT_DURATION_MINS*60*1000));  // eslint-disable-line no-unused-vars
                    if(date.getTime() === clientEvent.start.getTime() && clientEvent.className.indexOf('candTimeslot') < 0){
                        return true;
                    }
                });

                // If an event is already present it has already been checked for past. And if it is in the past  no need
                // to show the modal as it would have already been shown if required.
                if(!$scope.allowPast && (filteredEvents.length === 0 && $scope.inPast(date)) ){

                    $scope.pastModal.okCallback = $scope.schOptions.drop;
                    $scope.pastModal.okArgs = Array.prototype.slice.call(arguments);
                    if(!$scope.pastModal.okArgs){
                        $scope.pastModal.okArgs = [];
                    }
                    $scope.pastModal.context = this;
                    $scope.pastModal.okArgs[5] = true;   // inDigest = true, indicating we are inside $apply already.
                    $scope.pastModal.show = true;
                    $scope.$apply('$root.modal = pastModal');
                    return;
                }

                if(filteredEvents.length){
                    event = filteredEvents[0];
                }else{
                    event = {
                            allDay : allDay,
                            start : date,
                            interviewers : {},
                            location : '',
                            title: ''
                    };
                    event.end = new Date(event.start);
                    if(event.start.getHours() === 23){
                        endOfDay(event.end, event.start);
                    }else{
                        event.end.setHours(event.start.getHours()+ Math.floor($scope.INT_DURATION_MINS/60));
                    }
                }

                // TODO: Remove the return statements if confirmed that jquery draggable does not drop an element twice
                if(interviewerId){
                    if(event.interviewers[interviewerId]){
                        return;
                    }
                    event.interviewers[interviewerId] = $scope.interviewers[interviewerId];
                    if(!event.host && $scope.videoConferencingProperties.videoConferenceEnabled){
                        event.host = $scope.interviewers[interviewerId].EId;
                    }
                }
                if(locationEId){
                    if(event.location && event.location === locationEId){ // Location already dropped
                        return;
                    }
                    event.location = locationEId;
                    if(locationEId.charAt(0) === '_'){
                        event.tempLocName = $scope.allLocations[locationEId].tempLocName;
                    }
                }

                if(filteredEvents.length ){
                    if(event.existing){
                        event.dirty = true;
                    }
                    if(inDigest){
                        scheduler.updateEvent(event, interviewerId || locationEId);
                    }else{
                        $scope.$apply(function(){
                            scheduler.updateEvent(event, interviewerId || locationEId);
                        });
                    }

                }else{
                    if(inDigest){
                        scheduler.renderEvent(event, true, interviewerId || locationEId);
                    }else{
                        $scope.$apply(function(){
                            scheduler.renderEvent(event, true, interviewerId || locationEId);
                        });
                    }
                }
                $scope.reRenderCalender();
            },

            dayClick : function(date, allDay, jsEvent){
                if(!$scope.popUp.mode){
                    showAddPopUp(date);
                }

                if(jsEvent.pageY < 575){
                    $('#jv-addPopup').css({top: jsEvent.pageY-300+'px'});
                    $('#jv-addPopup').addClass('flip');
                }else{
                    $('#jv-addPopup').css({top: jsEvent.pageY-575+'px'});
                    $('#jv-addPopup').removeClass('flip');
                }
            },

            eventClick : function(event, jsEvent){
                if(event.className.length === 0){
                    // tempInterviewers: To overcome angular's weird anti-update behaviour(will remove once the issue is solved)
                    // Make this a local var
                    $scope.tempInterviewers = [];
                    // Omitting the _id property as it gives errors on rerender during close of popup as FC tried to replace it.
                    $scope.originalEvent = $scope.copyObj(event, ['interviewers', 'location', 'start', 'end', 'allDay', 'title', 'existing', 'dirty']);
                    $scope.popUp.origIntrvrs = angular.copy(event.interviewers);
                    $scope.popUp.origEventId = event._id;
                    angular.forEach(event.interviewers, function(interviewer){
                        if(interviewer){
                            $scope.tempInterviewers.push(interviewer);
                        }
                    });
                    $scope.popUp.date = event.start;
                    $scope.popUp.startTime = {h:event.start.getHours(), m:event.start.getMinutes()};
                    // Happens when the schedule reaches midnight(by resize, drag etc) - should actually be prevented by validation. May be a FC bug.
                    if(event === null){
                        event.end = new Date(event.start);
                        event.end.setDate(event.start.getDate() + 1);
                        event.setHours(0);
                        event.setMinutes(0);
                    }
                    $scope.popUp.endTime = {h:event.end.getHours(), m: event.end.getMinutes()};
                    if(event.location.charAt(0) === '_'){
                        $scope.popUp.otherLocation = $scope.allLocations[event.location] ? $scope.allLocations[event.location].name : '';
                        $scope.popUp.location = '';
                        $scope.popUp.origLocation = $scope.allLocations[event.location] ? $scope.allLocations[event.location].name : '';
                    }else{
                        $scope.popUp.location = event.location;
                        $scope.popUp.origLocation = event.location;
                        $scope.popUp.otherLocation ='';
                    }

                    $scope.popUp.mode = 'edit';
                    $scope.currEditedEvent = event;
                    $scope.$apply('popUp.interviewers = tempInterviewers');

                    if(jsEvent.pageY < 575){
                        $('#jv-addPopup').css({top: jsEvent.pageY-300+'px'});
                        $('#jv-addPopup').addClass('flip');
                    }else{
                        $('#jv-addPopup').css({top: jsEvent.pageY-575+'px'});
                        $('#jv-addPopup').removeClass('flip');
                    }
                }
            }
    };

    /**
     * Removes the interviewer from the side panel
     *
     */
    $scope.removeInterviewer = function(eid) {
        $scope.freebusy.removeResource(eid);
        delete $scope.interviewers[eid];
    };

    /**
     * Removes the location from the side panel
     *
     */
    $scope.removeLocation = function(eid){
        $scope.selLocationEId = null;
        $scope.pannelResouceloc[eid]=false;
        $scope.freebusy.removeResource(eid);
        delete $scope.$parent.selLocations[eid];
    };

    /**
     * Adds an interviewer to the side panel.
     *
     */
    $scope.addInterviewer = function(newInterviewer, skipFreebusy){
        // ToDo: String check is a quick fix for IE9 0 0 issue. Will visit later.
        if(newInterviewer === null || angular.isString(newInterviewer) || $scope.interviewers[newInterviewer.EId]){
            $scope.newInterviewer = null;
            return;
        }

        if(!newInterviewer.hasOwnProperty('sortIndex')){
            newInterviewer.sortIndex = $scope.$parent.sortIndex++;
        }
        $scope.$parent.interviewers[newInterviewer.EId] = angular.copy(newInterviewer);

        // Clearing out the ng-model so that the UI does not retain the last selected interviewer.
        $scope.newInterviewer = null;

        if(!skipFreebusy){
            $scope.freebusy.addResource(newInterviewer);
        }
    };

    $scope.addOtherLocation = function(){
        var location = angular.copy($scope.locationFeatures.otherLocation);
        var count = 0;
        for(var loc in $scope.allLocations){
            if(loc.charAt(0) === '_'){
                count++;
            }
        }
        $scope.selLocations['_'+count]={
            name: location,
            EId: '_'+count,
            tempLocName: location
        };
        $scope.allLocations['_'+count] = $scope.selLocations['_'+count];
        count++;
        $scope.locationFeatures.otherLocation = '';
    };
    /**
     * Adds a location to the side panel.
     *
     */
    $scope.addLocation = function(eid, skipFreebusy){
        var location;
        if(!eid){
            return;
        }
        if(!$scope.allLocations[eid] && eid.indexOf('loc-') > -1){
            //other location
            skipFreebusy = true;
            $scope.locationFeatures.otherLocation = eid.split('loc-')[1];
            $scope.addOtherLocation();
            return;
        }

        // TODO: Check if its already present
        location = $scope.$parent.selLocations[eid] = $scope.allLocations[eid];
        if(!location.hasOwnProperty('sortIndex')){
            location.sortIndex = $scope.$parent.sortIndex++;
        }
        // Clearing out the ng-model so that the UI does not retain the last selected location.
        $scope.selLocationEId = null;
        if(!skipFreebusy && $scope.isGcalEnabled() && location.email){
            $scope.freebusy.addResource(location);
            $scope.pannelResouceloc[eid]=true;
        }

    };

    var isDateAfterCurrentCalendarDate = function(date){
        //Add 8 days to the current cal date and see if date is beyond that. Because we fetch freebusy for 8 days upfront.
        var dateInFuture = new Date(moment($scope.currentCalendarDate).add(FREEBUSYENDDATE,'days'));
        if(typeof(date) === 'string'){
            date = moment(moment.tz(date,$window._jvselfUser.locale.timezone).format('YYYY-MM-DDTHH:mm:ss')).toDate();
        }
        //Compare dates using filter.
        if(date.getTime() > dateInFuture.getTime()){
            $scope.dateInFuture = true;
        }else {
            $scope.dateInFuture =  false;
        }
        return $scope.dateInFuture;
    };

    $scope.gotoDate = function(date){
        isDateAfterCurrentCalendarDate(date);
        if(typeof(date) === 'string'){
            //date string can be with/without time zone information
            if(date.split('T')[1]){
                date = moment(moment.tz(date, tz).format('YYYY-MM-DDTHH:mm:ss')).toDate();
            }else{
                date = moment(date).toDate();
            }
        }
        scheduler.gotoDate(date);
        $scope.currentCalendarDate = date;
    };

    var removeProp = function(arr, key){
        var obj;
        if(angular.isArray(arr)){
            for(var i = 0; i < arr.length; i++){
                obj = arr[i];
                if(obj.hasOwnProperty(key)){
                    delete obj[key];
                }
            }
        }
        return arr;
    };

    var nextStep = function(){
        var events = scheduler.fullCalendar('clientEvents', function(event){
            if(event.className && event.className.indexOf('candTimeslot') > -1){
                return false;
            }
            return true;
        });

        var schedules = [], cancelled =[], modified = [], invalid = false, originalEvents=[];
        var deletedIntrvrs ={}, addedIntrvrs = {}, eventsChanged = false,isModified = false;
        var url;
        $scope.$parent.schedules = {};
        $scope.$parent.modify = true;
        $scope.$parent.modifyOnlyMessage = arguments[0];

        angular.forEach(events, function(event){
            delete event.source;
        });

        var anyIntrvrRetained = function(event){
            var result = false;
            $.each(event.interviewers, function(eid){
                if(!addedIntrvrs[eid] && (!deletedIntrvrs[eid] || event.interviewers[eid].interviewEId !== deletedIntrvrs[eid].interviewEId)){
                    result = true;
                    return result;
                }
            });
            return result;
        };

        var isHostModified=function(event){
            if($scope.videoConferencingProperties.videoConferenceEnabled && event.original && event.original.useVC && event.host && event.originalHost && event.host !== event.originalHost){
                return true;
            }
            return false;
        };

        var includeConferenceLinkModified = function(event){
            if($scope.videoConferencingProperties.videoConferenceEnabled && (event.original && event.original.useVC !== $scope.videoConferencingProperties.includeConferenceLink)){
                return true;
            }
            return false;
        };

        var isLocationModified=function(event){
            if(event.location === event.original.locationEId || (!event.original.locationEId && event.location && event.original.location && $scope.allLocations[event.location].name && event.original.location === $scope.allLocations[event.location].name)){
                return false;
            }
            return true;
        };

        var isTimeModified=function(event){

            //Fix for HIRE-8942 && HIRE-8785
            // event.start and event.end are evaluated in userstimezone . Hence converting event.original.fromDate and toDate also in user timezone
            var originalFromDate = moment(moment.tz(event.original.fromDate, tz).format('YYYY-MM-DDTHH:mm:ss')).unix() * 1000;
            var originalToDate = moment(moment.tz(event.original.toDate, tz).format('YYYY-MM-DDTHH:mm:ss')).unix() * 1000;

            if(event.original && event.start && event.end && (event.start.getTime() === originalFromDate) && (event.end.getTime() === originalToDate)){
                return false;
            }
            return true;
        };

        events = angular.copy(events);
        /**
         * This method does not check for modifications as in if a interviewer was added or deleted. This only checks if a interview's time was modified and
         * how many original interviewers from that interview have been retained(not deleted or added). It also checks if the location of the event was modified.
         */
        var wasEventModified = function(event){
            if(event.original){
                if(isLocationModified(event) || isTimeModified(event) || !anyIntrvrRetained(event) || isHostModified(event) || includeConferenceLinkModified(event)){
                    return true;
                }
            }
            return false;
        };

        var createSchObj = function(event, type, filterId){
            var schedule = {}, interviewers = [];
            schedule.locationEId = event.location;
            if(schedule.locationEId.charAt(0) === '_'){
                schedule.otherLocation = $scope.allLocations[event.location].name;
            }
            if(event.location){
                schedule.locationName = $scope.allLocations[event.location].name;
            }
            schedule.fromDate = event.start.getTime();
            schedule.toDate = event.end.getTime();

            if($scope.videoConferencingProperties.videoConferenceEnabled){
                if(isHostModified(event)){
                    schedule.hostChange = true;
                }
                if(event.original && isTimeModified(event)){
                    schedule.timeChange = true;
                }
                if(event.original && includeConferenceLinkModified(event)) {
                    schedule.useVCChange = true;
                }
                schedule.useVC = $scope.videoConferencingProperties.includeConferenceLink || $scope.videoConferencingProperties.includeConferenceLinkViaCSS;
                if (type === 'CANCEL') {
                    schedule.host = event.hostEId;
                    schedule.meetingId = event.meetingId;
                } else {
                    schedule.host = event.host;
                    if(event.original){
                        schedule.meetingId = event.original.meetingId;
                    }
                }
            }

            $scope.$parent.schedInterviewers[type] = $scope.$parent.schedInterviewers[type] || {};
            // todo: Code smell of schedInterviewers
            if(type === 'CANCEL' && filterId){
                var interviewer = event.original.intrvrsMap[filterId];
                interviewers.push({'userEId': filterId, 'interviewEId': interviewer.interviewEId || ''});
                $scope.$parent.schedInterviewers[type][filterId] = interviewer;
            }else{
                angular.forEach(event.interviewers, function(interviewer, eid){
                    if(filterId){
                        if(eid === filterId){
                            interviewers.push({'userEId': eid, 'interviewEId': interviewer.interviewEId || ''});
                            $scope.$parent.schedInterviewers[type][eid] = interviewer;
                            $scope.$parent.schedInterviewers[type][eid].schedule = event.start;
                        }
                    }else if(type === 'RESCHEDULE'){
                        if(!addedIntrvrs[eid] && (!deletedIntrvrs[eid] || event.interviewers[eid].interviewEId !== deletedIntrvrs[eid].interviewEId)){
                            if(!interviewer.interviewEId && event.original && event.original.intrvrsMap[eid]) {
                                interviewer.interviewEId = event.original.intrvrsMap[eid].interviewEId;
                            }
                            interviewers.push({'userEId': eid, 'interviewEId': interviewer.interviewEId || ''});
                            $scope.$parent.schedInterviewers[type][eid] = interviewer;
                            $scope.$parent.schedInterviewers[type][eid].schedule = event.start;
                        }
                    }else{
                        interviewers.push({'userEId': eid, 'interviewEId': interviewer.interviewEId || ''});
                        $scope.$parent.schedInterviewers[type][eid] = interviewer;
                        $scope.$parent.schedInterviewers[type][eid].schedule = event.start;
                    }
                });
            }
            schedule.interviewers = angular.copy(interviewers);
            interviewers = [];
            if(schedule.interviewers && schedule.interviewers.length){
                return schedule;
            }
            else{
                return null;
            }
        };

        if((!events || $.isEmptyObject(events) || events.length < 2) && ($scope.cancelledEvents.length === 0)){
            $scope.showMsg('NO_EVENTS');
            return;
        }

        // Clear the cache
        $scope.$parent.eventsCache = [];
        $scope.$parent.schedInterviewers =  {};

        $scope.$parent.scheduledEvents = events;
        angular.forEach(events, function(event){
            var tempSchObj={};
            // Special events may be marked ignore - For ex:current time bar event.
            if(event.ignore){
                return;
            }

            // change condition?
            if($.isEmptyObject(event.interviewers)){
                $scope.showMsg($scope.format(i18n.NO_INTERVIEWER, {Date: ($filter('localeDateTime')(event.start, 'shortDate', 'MM/dd/yyyy')), Time: ($filter('localeDateTime')(event.start, 'shortTime', 'hh:mm:a'))}), true);
                invalid = true;
                isModified = true;
                return (false);
            }
            if(event.dirty || event.original){
                angular.forEach(event.interviewers, function(interviewer, eid){
                    if(event.original && !event.original.intrvrsMap[eid]){
                        addedIntrvrs[interviewer.EId] = interviewer;
                        tempSchObj = createSchObj(event, 'SCHEDULE', eid);
                        if(tempSchObj){
                            schedules.push(tempSchObj);
                            isModified = true;
                        }
                    }
                });

                if(event.original){
                    angular.forEach(event.original.intrvrsMap, function(interviewer, eid){
                        if(!event.interviewers[eid]){
                            deletedIntrvrs[interviewer.EId] = interviewer;
                            tempSchObj = createSchObj(event, 'CANCEL', eid);
                            if(tempSchObj){
                                cancelled.push(tempSchObj);
                                isModified = true;
                            }
                        }
                    });
                }
                if(!isTimeModified(event) && !$scope.ismodifyModal){
                    if(isLocationModified(event) || isHostModified(event) || includeConferenceLinkModified(event)){
                        isModified = true;
                    }
                }
                else{
                    isModified = true;
                }

                // Using liberal equality on location so that undefined and '' equate.
                if(wasEventModified(event)){
                    // exclude the newly added interviewer
                    tempSchObj = createSchObj(event, 'RESCHEDULE');
                    if(tempSchObj){
                        modified.push(tempSchObj);
                    }
                }
                else{
                    tempSchObj = createSchObj(event, 'RESCHEDULE');
                    if(tempSchObj){
                        originalEvents.push(tempSchObj);
                    }
                }
            }else if(!event.existing){
                tempSchObj = createSchObj(event, 'SCHEDULE');
                if(tempSchObj){
                    schedules.push(angular.copy(tempSchObj));
                    isModified = true;
                }
            }
            //added and deleted interviewers need to be cleared adter processing an event, since they are specific to an event.
            deletedIntrvrs = {};
            addedIntrvrs = {};

        });

        angular.forEach($scope.cancelledEvents, function(event){
            var tempSchObj = createSchObj(event, 'CANCEL');
            if(tempSchObj){
                cancelled.push(angular.copy(tempSchObj));
                isModified = true;
            }
        });

        if(!isModified && !$scope.$parent.modifyOnlyMessage){
            $scope.modifyModal.show=true;
            $scope.$parent.modify=false;
            $scope.$root.modal = $scope.modifyModal;
            $scope.ismodifyModal = true;
            return;
        }

        // ToDo: Remove dup code
        if(schedules && schedules.length){
            $scope.$parent.schedules['SCHEDULE'] ={};
            $scope.$parent.schedules['SCHEDULE']['schedules'] = schedules;
            eventsChanged = true;
        }
        if(cancelled && cancelled.length){
            $scope.$parent.schedules['CANCEL'] = {};
            $scope.$parent.schedules['CANCEL']['schedules'] = cancelled;
            eventsChanged = true;
        }
        if(modified && modified.length){
            $scope.$parent.schedules['RESCHEDULE']= {};
            $scope.$parent.schedules['RESCHEDULE']['schedules'] = modified;
            eventsChanged = true;
        }
        if(originalEvents.length > 0){
            $scope.$parent.schedules['ORIGINAL']= {};
            $scope.$parent.schedules['ORIGINAL']['schedules'] = originalEvents;
        }

        if(!eventsChanged && originalEvents && originalEvents.length){
            $scope.$parent.schedules['RESCHEDULE']= {};
            $scope.$parent.schedules['RESCHEDULE']['schedules'] = originalEvents;
        }


        if(!invalid){
            $scope.$parent.eventsCache = removeProp(scheduler.clientEvents(), 'source');
            $scope.$parent.fbResources = angular.copy($scope.freebusy.options.resources);
            $scope.$parent.gcalEventsCache = $scope.freebusy.gcalEvents();
            $scope.$parent.schedDate = scheduler.getDate();
            $scope.$parent.selectedTimezoneObj = $scope.selectedTimezoneObj.openSysId ?
            $scope.selectedTimezoneObj : ($scope.selectedTimezone ? JSON.parse($scope.selectedTimezone) : null);
            $(window).unbind('beforeunload'); // todo: prevent if other handlers are also unbound?(the N&M navaway)
            url='workflow-messager/'+$scope.params.applicationId+'/'+$scope.params.stateId;
            if($scope.params.groupId){
                url+='/'+$scope.params.groupId;
            }
            $rootScope.parentScope = {
                modify: $scope.$parent.modify,
                modifyOnlyMessage: $scope.$parent.modifyOnlyMessage,
                schedules: $scope.$parent.schedules,
                fbResources: $scope.$parent.fbResources,
                eventsCache: $scope.$parent.eventsCache,
                gcalEventsCache: $scope.$parent.gcalEventsCache,
                schedDate: $scope.$parent.schedDate,
                selectedTimezoneObj: $scope.$parent.selectedTimezoneObj,
                schedInterviewers: $scope.$parent.schedInterviewers,
                scheduledEvents: $scope.$parent.scheduledEvents,
                cancelledEvents: $scope.$parent.cancelledEvents,
                interviewers: $scope.$parent.interviewers,
                allLocations: $scope.allLocations,
                videoConferencingProperties: $scope.videoConferencingProperties
            };
            $location.path(url, false, true);
        }
    };

    /**
     * Takes the control to the next page where a message can be sent to scheduled interviewers.
     *
     * * Validates the events added in the calendar.
     * * Creates the schedule object(and set it on $parent) that the messager page will post to server.
     * * Stores all Scheduled interviewers in a $parent object(schedInterviewers), this is used by the messager page for displaying all scheduled interviewers.
     * * Caches all the events currently added to the calendar($parent.eventsCache), this is used to populate the calendar if the user comes back to this page
     *   by clicking on 'Back to scheduler' in the messager page.
     */
    $scope.next = function(){
        var modifyMessageOnly = arguments[0];
        if(!$scope.videoConferencingProperties.videoConferenceEnabled || ( !$scope.videoConferencingProperties.includeConferenceLink && !$scope.videoConferencingProperties.includeConferenceLinkViaCSS )){
            nextStep(modifyMessageOnly);
        } else {
            var events = scheduler.fullCalendar('clientEvents', function(event){
                if(event.className && event.className.indexOf('candTimeslot') > -1){
                    return false;
                }
                return true;
            });

            var hosts = [];
            for(var i=0; i<events.length; i++){
                if(events[i].host){
                    hosts.push(events[i].host);
                }
            }

            if (hosts.length === 0) {
                nextStep(modifyMessageOnly);
            } else {
                candidates.checkInterviewersVideoConferencingAccount($routeParams.applicationId, {userEIds: hosts}, function(res){
                    if(res && res.nonExistingAccounts && res.nonExistingAccounts.length > 0){
                        $scope.videoConferencingProperties.showError = true;
                        $scope.videoConferencingProperties.users = res.nonExistingAccounts.join(', ');
                    }else{
                        nextStep(modifyMessageOnly);
                    }
                }, function(fail){
                    $log.error(fail);
                });
            }
            
        }
    };

    /**
     * Validates the pop up form.
     * $scope.schForm.$invalid - indicates the form validation(in directive) - format of the timepicker hh:mm(am/pm)
     * $scope.timeInValid - if end time is earlier than start time - in $watch of popup endtime
     */
    var isFormValid = function(){
        if($scope.schForm.$invalid || $scope.timeInValid){
            return false;
        }
        return true;
    };

    var emptyEvent = function(){
        return {
            allDay : false,
            start : {},
            end:{},
            interviewers : {},
            location : '',
            title: ''
        };
    };

    // Private methods

    /**
     * Checks if an event is valid to be added or updated on the calendar.
     * If not valid, shows an appropriate message or invalidates the respective flag.
     */
    var isEventValid = function(startDate, endDate){
        var valid = true;
        // ToDo: remove this validation(this is being done in the $watch already)
        if(valid && endDate <= startDate){
            $scope.timeInvalid = true;
            valid = false;
        }
        return valid;
    };



    /**
     * A very basic conversion of a map to an array.
     * If getKeys is true will return an array of keys(Object.keys is not browser compatible)
     *
     */
    var toMap = function(array, key){
        var map = {};
        for(var i = 0; i < array.length; i++){
            if(array[i].hasOwnProperty(key)){
                map[array[i][key]] = array[i];
            }
        }
        return map;
    };

    /**
     * Adding the schedule on click of save in the popup form.
     * ToDo: Can _id property be used for checking if an event exists?(running the risk of dep on a private var)
     *       Can we skip the event exists check while updating an event?
     */

    $scope.addSchedule = function(){
        var startDate, endDate, event, p = $scope.popUp;
        if(!isFormValid()){
            return;
        }

        if($scope.popUp.mode === 'edit' && !$.isEmptyObject($scope.currEditedEvent)){
            event = $scope.currEditedEvent;
            if(event.existing){
                event.dirty = true;
            }
        }else{
            event = emptyEvent();
        }

        startDate = new Date(p.date);
        startDate.setHours(p.startTime.h);
        startDate.setMinutes(p.startTime.m);

        endDate = new Date(p.date);
        endDate.setHours(p.endTime.h);
        endDate.setMinutes(p.endTime.m);

        // Validate
        // If mode is 'edit' check if the edited  event.start(of currEditedevent) was already inPast inwhich case we don't show the past modal
        if( ( ($scope.popUp.mode !== 'edit') || ($scope.popUp.mode === 'edit' && !$scope.inPast(event.start) )) && !$scope.allowPast && $scope.inPast(startDate)){
            $scope.pastModal.okCallback = $scope.addSchedule;
            $scope.pastModal.okArgs = Array.prototype.slice.call(arguments);
            $scope.pastModal.show = true;
            $scope.$root.modal = $scope.pastModal;
            return;
        }

        if(!isEventValid(startDate, endDate, event)){
            return;
        }

        // Create event object
        event.start = startDate;
        event.end = endDate;

        // Select2 needs an array. If event was added through the popup inerviewers would be an array
        if(angular.isArray(p.interviewers)){
            event.interviewers = angular.copy(toMap(p.interviewers, 'EId'));
        }else{
            event.interviewers = angular.copy(p.interviewers);
        }

        if($scope.videoConferencingProperties.videoConferenceEnabled){
            event.host = p.interviewers[0].EId;
        }

        //Making sure we send the interviewEId when we modify a schedule by removing and adding the same user: NV-HIRE:2837
        if( event.original && (event.original.interviewers.length === $scope.size(event.interviewers)) ){
            $scope.interviewIdMap = {};
            angular.forEach(event.original.interviewers,function(interviewer){
                $scope.interviewIdMap[interviewer.EId] = interviewer.interviewEId;
            });

            angular.forEach(event.interviewers,function(interviewer){
                if($scope.interviewIdMap[interviewer.EId]){
                    interviewer.interviewEId = $scope.interviewIdMap[interviewer.EId];
                }
            });
        }

        if($scope.locationFeatures.isOtherPopup){
            var location = angular.copy(p.otherLocation);
            var count = 0;
            for(var i in $scope.allLocations){
                if(i.charAt(0) === '_'){
                    count++;
                }
            }

            var loc={
                name: location,
                EId: '_'+count,
                tempLocName: location
            };
            $scope.allLocations['_'+count] = loc;
            count++;
            event.otherLocation = angular.copy(location);
            p.otherLocation = '';
            event.location = loc.EId;
        }else{
            event.location = p.location;
            p.otherLocation = '';
        }

        // Render or update event on canvas
        if(angular.isDefined(event._id)){
            // TODO: Use ngevent rendering on FB by passing a 4th paramter of resourceId or resourceIds
            scheduler.fullCalendar('updateEvent', event, true);
            if(event.interviewers){
                angular.forEach(event.interviewers, function(interviewer){
                    $scope.freebusy.replaceEvent(event, interviewer);
                });
            }
            if(event.location && event.location.charAt(0) !== '_'){
                $scope.freebusy.replaceEvent(event, {EId:event.location});
            }
        }else{
            // TODO: Use ngevent rendering on FB by passing a 4th paramter of resourceId or resourceIds
            scheduler.fullCalendar('renderEvent', event, true);
            if(event.interviewers){
                angular.forEach(event.interviewers, function(interviewer){
                    $scope.freebusy.addEvent(event, interviewer.EId);
                });
            }
            if(event.location && event.location.charAt(0) !== '_'){
                $scope.freebusy.addEvent(event, event.location);
            }
        }
        $scope.popUp.addedResources = [];
        $scope.popUp.removedResources = [];
        $scope.popUp.origIntrvrs = {};
        $scope.popUp.origEventId = '';
        $scope.popUp.mode = '';
        $scope.originalEvent = {};
        $scope.currEditedEvent = {};
    };

    $scope.removeSchedule = function($event, eventId){
        var event;
        $event.preventDefault();
        $event.stopPropagation();
        event = scheduler.clientEvents(eventId)[0];
        if(event.existing){
            $scope.$parent.cancelledEvents.push($scope.copyObj(event, ['original.meetingId', 'original.hostEId', 'original.useVC', 'interviewers', 'location', 'start', 'end', 'allDay', 'title', 'existing', 'dirty']));
        }
        scheduler.removeEvents(eventId);
    };

    $scope.currentDate = function(){
        return scheduler.getDate();
    };

    /**
     * A very basic conversion of a map to an array.
     * If getKeys is true will return an array of keys(Object.keys is not browser compatible)
     *
     */
    $scope.toArray = function(map){
        var arr =[];
        angular.forEach(map, function(value, key){
            if(map.hasOwnProperty(key)){
                arr.push(value);
            }
        });
        return arr;
    };

    var isIntrvInEvents = function(eid){
        var events, result = false;
        if($scope.popUp.mode === 'edit'){
            events = $scope.eventsForResource(eid, $scope.popUp.origEventId);
        }else{
            events = $scope.eventsForResource(eid);
        }

        if(events && events.length){
            result = true;
        }
        return result;
    };

    var isIntvrInPopup = function(eid){
        var result = false;
        // TODO : use jquery each so that you can break out of the loop.
        angular.forEach($scope.popUp.interviewers, function(interviewer){
            if(interviewer.EId === eid){
                result = true;
            }
        });
        return result;
    };

    // Rendering the inline changes made to the interviewers in the popup form.
    // Maintains the sync between the popup and the event on the canvas
    $scope.$watch('popUp.interviewers', function(interviewers){
        if(interviewers.length === 0){
            return;
        }
        if($scope.isGcalEnabled()){
            // ToDO: looks scary - simplify the calculations - iPad workaruond for gcal
            angular.forEach(interviewers, function(interviewer){
                if(!interviewer.ProfilePictureUrl){
                    $scope.setProfilePicUrl(interviewer);
                }
                if(!$scope.popUp.origIntrvrs[interviewer.EId] && !$scope.freebusy.isResourceRendered(interviewer.EId)){
                    $scope.popUp.addedResources.push(interviewer);
                }
            });

            angular.forEach($scope.popUp.origIntrvrs, function(interviewer){
                if(!isIntvrInPopup(interviewer.EId) &&  !isIntrvInEvents(interviewer.EId) && !$scope.interviewers[interviewer.EId]){
                    $scope.popUp.removedResources.push(interviewer);
                }

            });

            for (var i = 0; i <  $scope.popUp.addedResources.length; i++){
                if(!isIntvrInPopup($scope.popUp.addedResources[i].EId)){
                    $scope.popUp.removedResources.push($scope.popUp.addedResources[i]);
                    $scope.popUp.addedResources.splice(i--,1);
                }
            }

            for (var j = 0; j <  $scope.popUp.removedResources.length; j++){
                if(isIntvrInPopup($scope.popUp.removedResources[j].EId)){
                    $scope.popUp.addedResources.push($scope.popUp.removedResources[j]);
                    $scope.popUp.removedResources.splice(j--,1);
                }
            }


            if($scope.popUp.mode === 'edit' && angular.isDefined(interviewers)){
                $scope.currEditedEvent.interviewers = interviewers;
                //TODO: Shouldn't this be updateevent?
                scheduler.fullCalendar('renderEvent', $scope.currEditedEvent, true);
            }
            //If modify schedule there are no interviewers in the addedResources so copy from  popUp.interviewers.
            //When user hits back both modify and schedule flow go through the same flow starting from  plotFbEvents($scope.eventsCache); if cache exists
            //You want to do this also when user is on modify flow and is scheduling for a date in the future.
            if($scope.mode !== 'modifySchedule' || ($scope.eventsCache.length) || ( ($filter('date')($scope.currentCalendarDate, 'MM/dd/yyyy')  !==  $filter('date')(new Date(), 'MM/dd/yyyy')  ) ) ){
                $scope.popUp.addedResources = angular.copy($scope.popUp.interviewers);
            }

            $scope.freebusy.addResources(angular.copy($scope.popUp.addedResources));
            //You dont want to remove resources if the user has hit back as it also removes the original user. Eg if event has a and b user hits back removes b and tried to add c a gets removed and only c shows up in the freebusy.
            if($scope.popUp.removedResources.length && !$scope.eventsCache.length){
                $scope.freebusy.removeResources(angular.copy($scope.popUp.removedResources));
            }
        }
    },true);

    // Rendering the inline changes made to the Loaction in the popup form.
    // Maintains the sync between the popup and the event on the canvas
    $scope.$watch('popUp.location', function(location){
        if(!location){
            return;
        }
        if($scope.isGcalEnabled()){
            if($scope.popUp.origLocation !== location){
                if($scope.popUp.prevLocation && $scope.popUp.origLocation !== $scope.popUp.prevLocation && !$scope.pannelResouceloc[$scope.popUp.prevLocation]){
                    $scope.freebusy.removeResource($scope.popUp.prevLocation);
                }
                $scope.freebusy.addResource($scope.allLocations[location]);
                $scope.popUp.prevLocation = location;
            }
        }
    });

    var validateTime = function(startTime, endTime){
        // Remove - Watch + Validation + Form validation dependency
        if(!endTime || $scope.schForm.$invalid){
            $scope.timeInValid = false;
            return;
        }

        if($scope.popUp.mode){
            if((endTime.h < startTime.h)  ||  (endTime.h === startTime.h && endTime.m <= startTime.m) ){
                $scope.timeInValid = true;
            }else{
                $scope.timeInValid = false;
            }
        }
    };

    // Checking if the end time is before or same as start time while the user edits the timepicker
    // Validation is not done if the formatting is not proper - form validation in the directive.
    $scope.$watch('popUp.endTime', function(endTime){
        validateTime($scope.popUp.startTime, endTime);
    });

    $scope.$watch('popUp.startTime', function(startTime){
        validateTime(startTime, $scope.popUp.endTime);
    });

    var getTodayInUserTimezone = function(){
        var userTimeZone = $window._jvselfUser.locale.timezone;
        var dateObject = new Date( moment.tz(new Date(),userTimeZone).format('MM/DD/YYYY') );
        return dateObject;
    };

    $scope.$watch('popUp.date', function(newDate){
        //VbToDo:
        //Check the current date of calendar and compare with new date
        // if not same only then invoke gotodate
        if(newDate){
            if($scope.mode === 'schedule' && !$scope.todaysDateSetInUserTimeZone){
                //for scheudler interviews we need to default calendar to today in users timezone. We only want to do this the first time user lands on the page
                var todayInUserTimeZone  = getTodayInUserTimezone();
                $scope.todaysDateSetInUserTimeZone  = true;
                $scope.gotoDate(todayInUserTimeZone);
            }else{
                $scope.gotoDate(newDate);
            }

        }
    });

    $scope.eventsForResource = function(resourceId, filterId){
        var events;
        if(filterId){
            events = scheduler.clientEvents(function(event){
                if( (event.hasOwnProperty('_id') && (event._id !== filterId))  &&  ((event.interviewers && event.interviewers[resourceId]) || (event.location === resourceId)) ){
                    return true;
                }
            });
        }else{
            events = scheduler.clientEvents(function(event){
                if((event.interviewers && event.interviewers[resourceId]) || (event.location === resourceId)){
                    return true;
                }
            });
        }
        return events;
    };

    /**
     * Closes the popup.
     * It remove the events rendered by the object that used to hold the intermediary
     * changes and renders the event as it was before the popup was shown.
     */
    $scope.closePopUp = function(){
        var remRes = [], addRes = [];
        if($scope.popUp.mode === 'edit'){
            if(!$.isEmptyObject($scope.currEditedEvent) && angular.isDefined($scope.currEditedEvent._id)){
                scheduler.fullCalendar('removeEvents', $scope.currEditedEvent._id);
            }
            if(!$.isEmptyObject($scope.originalEvent)){
                $scope.originalEvent.id = $scope.currEditedEvent._id;
                $scope.originalEvent.original = angular.copy($scope.currEditedEvent.original);
                scheduler.fullCalendar('renderEvent', $scope.originalEvent, true);
            }
        }

        angular.forEach($scope.popUp.origIntrvrs, function(intrvr, eid){
            if(!isIntvrInPopup(eid) &&  !$scope.freebusy.isResourceRendered(eid)){
                addRes.push(intrvr);
            }
        });

        angular.forEach($scope.popUp.interviewers, function(interviewer){
            if(!$scope.popUp.origIntrvrs[interviewer.EId] && !isIntrvInEvents(interviewer.EId) && !$scope.interviewers[interviewer.EId]){
                remRes.push(interviewer);
            }
        });

        $scope.freebusy.addResources(addRes);
        $scope.freebusy.removeResources(remRes);
        if($scope.popUp.prevLocation !== $scope.popUp.origLocation && !$scope.pannelResouceloc[$scope.popUp.prevLocation]){
            $scope.freebusy.removeResource($scope.popUp.prevLocation);
        }
        $scope.popUp.prevLocation='';
        $scope.popUp.origLocation ='';
        $scope.popUp.addedResources = [];
        $scope.popUp.removedResources = [];
        $scope.popUp.origIntrvrs = {};
        $scope.popUp.origEventId = '';
        $scope.popUp.otherLocation = '';
        $scope.currEditedEvent ={};
        $scope.originalEvent = {};
        $scope.locationFeatures.isOtherPopup = false;
        $scope.popUp.mode = '';
    };


    var resetPopUp = function(popUp){
        popUp.interviewers = [];
        popUp.location = '';
        popUp.date = new Date();
        popUp.startTime = {h:0, m:0};
        popUp.endTime = {h:0, m:0};
        popUp.mode = '';
    };

    /**
     * Used to check if any events exist between the start and end time range.
     * Returns all the events that exists between that time range.
     *
     *  If end is passed - it checks if there are any events between the time range
     *
     *  Only start is passed - checks if there are any events that exist in the given start time
     *
     *  _eventId - Exclude the event with this ID, ususally the event that is being compared. Passed along with 'end', since 'clientEvents' has all the rendered events the passed in id is used to exclude
     *             from comparing it with itself.
     */
    var eventExists = function(start, end, _eventId){   // eslint-disable-line
        var filteredEvents = [];
        //VBTODO: if(end && _eventId)
        if(end){
            filteredEvents = scheduler.fullCalendar('clientEvents', function(clientEvent){
                if(!clientEvent.ignore && end > clientEvent.start && start < clientEvent.end && clientEvent._id !== _eventId){
                    return true;
                }
            });
        }else{ // ToDo: Check and Remove else block - prolly not being used.
            filteredEvents = scheduler.fullCalendar('clientEvents', function(clientEvent){
                if(!clientEvent.ignore && start >= clientEvent.start && start <= clientEvent.end){
                    return true;
                }
            });
        }
        return filteredEvents;
    };

    /**
     * Determines if the edit is valid by checking the folowing things:
     *
     * 1) If there are any events in the newly dragged or resized interval.
     *
     */
    var isEditValid = function(event){ // eslint-disable-line
        if(eventExists(event.start, event.end, event._id).length){
            return false;
        }
        return true;
    };

    /**
     * Tells if the passed in date is in the past.
     */
    $scope.inPast = function(date){
        // Removed Date.now() due to IE8 incompatibility
        return date.getTime() < new Date().getTime();
    };


    /**
     * Tells if the passed in date object represents today.
     */
    var isToday = function(date){
        var today = new Date();
        if(date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getYear() === today.getYear()){
            return true;
        }
        return false;
    };

    var getNestedObj = function(source, prop){
        var propIndex = prop.indexOf('.');

        if (propIndex === -1) {
            return {
                value: source[prop],
                key: prop
            };
        }

        return getNestedObj(source[prop.substring(0, propIndex)], prop.substring(propIndex + 1));
    };
    /**
     * Returns a deep copy of the selected properties(props) on the source object.
     */
    $scope.copyObj = function(source, props){
        // Doing manual copy as angular.copy gave a RangeError: Maximum call stack size exceeded
        // Initial inspection points towards the recursive 'source' reference
        var dest = {};
        for(var i = 0; i < props.length; i++){
            var objToCopy = getNestedObj(source, props[i]);
            dest[objToCopy.key] = angular.copy(objToCopy.value);
        }
        return dest;
    };

    $scope.sameDay = function(date1, date2){
        if(date1.getDate() === date2.getDate() && date1.getMonth() === date2.getMonth() && date1.getYear() === date2.getYear()){
            return true;
        }
        return false;
    };

    var mergeSlots = function(timeslotArr, current, next, mergedSlots){
        var currSlot = timeslotArr[current];
        if(next < timeslotArr.length){
            var nextSlot = timeslotArr[next];
            if(nextSlot.start > currSlot.start && nextSlot.start <= currSlot.end){
                currSlot.end = nextSlot.end;
                currSlot.endStr = nextSlot.endStr;
                mergeSlots(timeslotArr, current, ++next, mergedSlots);
            }else{
                mergedSlots.push(currSlot);
                mergeSlots(timeslotArr, next, ++next, mergedSlots);
            }
        }else{
            mergedSlots.push(currSlot);
        }
    };

    var addInterviewersAndMeetingRooms = function(){
        var j=0;
        var interviewersObj = $scope.selfSchedule.availabilityRequest;
        for(j=0; j< interviewersObj.interviewers.length; j++){
            for(var k=0; k<interviewersObj.interviewers[j].interviewers.length; k++){
                var interviewer = interviewersObj.interviewers[j].interviewers[k];
                interviewer.fullName = interviewer.firstName + ' ' + interviewer.lastName;
                interviewer.EId = interviewer.userEId;
                interviewer.userProfilePhotoUrl = $scope.$root.jvUrls.admin+'/action/user-details/employee/'+interviewer.userEId+'/profilePhoto?size=s';
                if(!$scope.$parent.reRenderEvents) {
                    $scope.addInterviewer(interviewer);
                }
            }
        }
        if(interviewersObj.meetingRooms && interviewersObj.meetingRooms.length > 0){
            for(j=0; j< interviewersObj.meetingRooms.length; j++){
                $scope.addLocation('loc-'+interviewersObj.meetingRooms[j], false);
            }
        }
    };

    var showCandidateAvailability = function(){
        $scope.selfSchedule.candidateGroupSlots = null;
        var i=0;
        var mergedSlots = [];
        scheduler.fullCalendar('removeEvents', function(event){
            if(event.className && event.className.indexOf('candTimeslot') > -1){
                return true;
            }
            return false;
        });

        var selectedSlots = $filter('orderBy')($scope.selfSchedule.candidateAvailability.selectedSlots, 'start');

        mergeSlots(selectedSlots, 0, 1, mergedSlots);
        $scope.timeZone.timezone = $scope.timeZone.openSysId;

        if(mergedSlots.length > 0){
            $scope.selfSchedule.candidateGroupSlots = {};
        }

        for(i=0; i<mergedSlots.length; i++){
            var slot = mergedSlots[i];
            var jNow = new Date(slot.start);
            var jEnd = new Date(slot.end);

            var candEvent = {
                start: (moment.tz(jNow, $scope.timeZone.openSysId).format('YYYY-MM-DDTHH:mm:ss')),
                end: (moment.tz(jEnd, $scope.timeZone.openSysId).format('YYYY-MM-DDTHH:mm:ss')),
                title:'',
                allDay:false,
                editable:false,
                startEditable: false,
                durationEditable: false,
                ignore:true,
                backgroundColor: 'rgba(55,178,74,0.4)',
                className:'candTimeslot',
                textColor: 'rgb(0,0,0)'
            };
            scheduler.fullCalendar('renderEvent', candEvent, true);
            var groupName = $filter('localeDateTime')(jNow, 'shortDate', 'MM/dd/yyyy', false, $scope.timeZone);
            $scope.selfSchedule.candidateGroupSlots[groupName] = $scope.selfSchedule.candidateGroupSlots[groupName] || [];

            var endDate = moment.tz(jEnd, $scope.timeZone.openSysId).format('MM-DD-YYYY');
            var startDate = moment.tz(jNow, $scope.timeZone.openSysId).format('MM-DD-YYYY');
            // time slot starting on same day but ending on next / different day
            if (endDate !== startDate) {
                var spillOverGroupName = $filter('localeDateTime')(jEnd, 'shortDate', 'MM/dd/yyyy', false, $scope.timeZone);
                var newEnd = moment.tz(jNow, $scope.timeZone.openSysId).hour(0).minutes(0).seconds(0).valueOf();
                var newStart = moment.tz(jEnd, $scope.timeZone.openSysId).hour(0).minutes(0).seconds(0).valueOf();

                $scope.selfSchedule.candidateGroupSlots[groupName].push({
                    start: $filter('localeDateTime')(jNow, 'shortTime', 'hh:mm a', false, $scope.timeZone),
                    end: $filter('localeDateTime')(new Date(newEnd), 'shortTime', 'hh:mm a', false, $scope.timeZone),
                    stringData: candEvent.start
                });
                // Adding the condition for not adding the same time in the availability slots.
                if(new Date(newStart).getTime() !== jEnd.getTime()) {
                    $scope.selfSchedule.candidateGroupSlots[spillOverGroupName] = $scope.selfSchedule.candidateGroupSlots[spillOverGroupName] || [];
                    $scope.selfSchedule.candidateGroupSlots[spillOverGroupName].push({
                        start: $filter('localeDateTime')(new Date(newStart), 'shortTime', 'hh:mm a', false, $scope.timeZone),
                        end: $filter('localeDateTime')(jEnd, 'shortTime', 'hh:mm a', false, $scope.timeZone),
                        stringData: candEvent.end
                    });
                }
            // time slot starting / ending on same day
            } else {
                $scope.selfSchedule.candidateGroupSlots[groupName].push({
                    start: $filter('localeDateTime')(jNow, 'shortTime', 'hh:mm a', false, $scope.timeZone),
                    end: $filter('localeDateTime')(jEnd, 'shortTime', 'hh:mm a', false, $scope.timeZone),
                    stringData: candEvent.start
                });
            }
        }
    };

    /**
     * Human readable representation of date and time.
     *
     */
    var dateString = function(date, separator){ //eslint-disable-line
        separator = separator || ', ';
        if(!date){
            return '';
        }

        return date.toDateString() + separator + date.toLocaleTimeString();
    };
    $scope.$watch('newInterviewer',function(newValue){
        if(newValue){
            $scope.setProfilePicUrl(newValue, $scope.addInterviewer);
        }
    },true);
    /**
     * Sorry for the code - should change once images are integrated into select2
     */
    $scope.setProfilePicUrl = function(user, callback, lookup, propName){
        if(!user){
            return;
        }

        var postData = {};
        propName = propName || 'ProfilePictureUrl';
        postData.eid = user.EId;
        postData.property = propName;
        // First try looking up the cache
        if($scope.$parent.userPropsCache[user.EId] && $scope.$parent.userPropsCache[user.EId][propName]){
            user[propName] = $scope.$parent.userPropsCache[user.EId][propName];
            if(callback){
                callback(user, !$scope.isGcalEnabled());
            }

        }else{
            /**
             * SMK: hiding profile pic url call for now
             */
            if(postData.property !== 'ProfilePictureUrl'){
                $scope.addLoading('candidates.userProperty');
                candidates.userProperty(postData, function(data){
                    if(data.userProperty){
                        user[propName] = data.userProperty.propertyValue;
                        $scope.$parent.userPropsCache[user.EId] = $scope.userPropsCache[user.EId] || {};
                        $scope.$parent.userPropsCache[user.EId][propName] = data.userProperty.propertyValue;
                    }
                    if(callback){
                        callback(user, !$scope.isGcalEnabled());
                    }

                    $scope.removeLoading('candidates.userProperty');

                }, function(){
                    if(callback){
                        callback(user, !$scope.isGcalEnabled());
                    }
                    $scope.removeLoading('candidates.userProperty.error');
                });
            }else{
                if(callback){
                    callback(user, !$scope.isGcalEnabled());
                }
            }
        }
    };

    var renderSchedEvents = function(schedEvents){
        var earliestEventStart;
        tempLocCount=0;
        angular.forEach(schedEvents, function(event){
            if(event.location && event.location.charAt(0) === '_'){
                var loc = {
                    name: event.otherLocation || (event.original ? event.original.location : '') ,
                    EId: '_'+tempLocCount
                };
                $scope.allLocations['_'+tempLocCount] = loc;
                event.location = '_'+tempLocCount;
                tempLocCount++;
            }
            if(!event.ignore){
                if(!earliestEventStart){
                    earliestEventStart = event.start;
                }else{
                    earliestEventStart = event.start < earliestEventStart ? event.start : earliestEventStart;
                }
                scheduler.fullCalendar('renderEvent', event, true);
            }
        });

        if(earliestEventStart){
            $scope.gotoDate(earliestEventStart);
        }else{
            // This is probably not needed, check and remove.
            scheduler.gotoDate(new Date());
        }
    };

    var renderFbEvents = function(gCalEvents){
        var fbEvents = [];
        angular.forEach($scope.freebusy.options.resources, function(resource){
            angular.forEach($scope.eventsForResource(resource.id), function(event){
                fbEvents.push($scope.freebusy.createFreeBusyEvent(event, resource.id));
            });
        });
        if(gCalEvents){
            fbEvents = fbEvents.concat(gCalEvents);
        }
        $scope.freebusy.options.events = fbEvents;
        $scope.$broadcast($scope.FREEBUSY_NAMESPACE+'.refresh', $scope.freebusy.options);
    };

    var fetchGcalEvents = function(resourceIds){
        var gCalEvents = [], serverGcalEvents = [];
        angular.forEach(resourceIds, function(resource, eid){
            if($scope.gcalEventsCache[eid]){
                gCalEvents = gCalEvents.concat($scope.gcalEventsCache[eid]);
                delete resourceIds[eid];
            }
        });
        if(!$.isEmptyObject(resourceIds)){
            var userids=[],locids=[];
            angular.forEach(Object.keys(resourceIds), function(index){
                if(index && index.indexOf('loc-')>-1){//Ids for Free busy of Resources
                    $scope.pannelResouceloc[index]=true;
                    if($scope.allLocations[index].email){
                        locids.push(index.split('loc-')[1]);
                    }
                }else{
                    userids.push(index);
                }
            });
            if(userids && userids.length){
                $scope.addLoading('candidates.gcalEvents');
                candidates.gCalEvents($scope.serializeArray(userids, 'userId'), $rootScope.normalizeDates($scope.dateDiff(FREEBUSYSTARTDATE).getTime()),
                        $rootScope.normalizeDates($scope.dateDiff(FREEBUSYENDDATE).getTime()), $scope.selectedTimezoneObj.id, function(response){
                    serverGcalEvents = $scope.freebusy.createGCalEvents(response.freeBusyInfo);
                    if(angular.isArray(serverGcalEvents) && serverGcalEvents.length){
                        gCalEvents = gCalEvents.concat(serverGcalEvents);
                    }
                    /** Code smell: Use promise and chain them **/
                    //renderSchedEvents(schedEvents);
                    renderFbEvents(gCalEvents);
                    $scope.removeLoading('candidates.gcalEvents');
                });
            }
            if(locids && locids.length){
                $scope.addLoading('candidates.gCalEventsResource');
                candidates.gCalEventsResource($scope.serializeArray(locids, 'locationId'), $rootScope.normalizeDates($scope.dateDiff(FREEBUSYSTARTDATE).getTime()),
                        $rootScope.normalizeDates($scope.dateDiff(FREEBUSYENDDATE).getTime()), $scope.selectedTimezoneObj.id, function(response){
                    serverGcalEvents = $scope.freebusy.createGCalEvents(response.freeBusyInfo,true);
                    if(angular.isArray(serverGcalEvents) && serverGcalEvents.length){
                        gCalEvents = gCalEvents.concat(serverGcalEvents);
                    }
                    /** Code smell: Use promise and chain them **/
                    //renderSchedEvents(schedEvents);
                    renderFbEvents(gCalEvents);
                    $scope.removeLoading('candidates.gCalEventsResource');
                });
            }
        }else{
            //renderSchedEvents(schedEvents);
            renderFbEvents(gCalEvents);
        }
    };

    var profilePicsFixMe = function(userIds, resourceIds,  schedEvents){
        angular.forEach($scope.freebusy.options.resources, function(resource){
            if(userIds[resource.id] && $scope.$parent.userPropsCache[resource.id]){
                resource.user[propName] = $scope.$parent.userPropsCache[resource.id][propName]; // eslint-disable-line
            }
        });
        /** Code smell: Use promise and chain them **/
        renderSchedEvents(schedEvents);
        if($scope.isGcalEnabled()){
            fetchGcalEvents(resourceIds, schedEvents);
        }
    };

    var profilePics = function(userIds, resourceIds,  schedEvents){ //eslint-disable-line
        var propName = 'ProfilePictureUrl';
        $scope.addLoading('candidates.propsForUser');
        candidates.propForUsers(propName, Object.keys(userIds) , function(response){
            var intrvr;
            angular.forEach(response.usersProperty, function(userProp){
                intrvr = $scope.$parent.interviewers[userProp.userEId];
                if(intrvr){
                    intrvr[propName] = userProp.propertyValue;
                    $scope.$parent.userPropsCache[userProp.userEId] = $scope.userPropsCache[userProp.userEId] || {};
                    $scope.$parent.userPropsCache[userProp.userEId][propName] = userProp.propertyValue;
                }
            });
            angular.forEach($scope.freebusy.options.resources, function(resource){
                if(userIds[resource.id] && $scope.$parent.userPropsCache[resource.id]){
                    resource.user[propName] = $scope.$parent.userPropsCache[resource.id][propName];
                }
            });
            /** Code smell: Use promise and chain them **/
            renderSchedEvents(schedEvents);
            if($scope.isGcalEnabled()){
                fetchGcalEvents(resourceIds, schedEvents);
            }
            $scope.removeLoading('candidates.propsForUser');
        },
        function(){
            fetchGcalEvents(resourceIds, schedEvents);
            $scope.removeLoading('candidates.propForUsers.error');
        });
    };

    $scope.dateDiff = function(difference, reference){
        var diff = getTodayInUserTimezone();
        reference = reference || $scope.currentCalendarDate;
        if( reference.getMonth() !== diff.getMonth() ){
            diff.setMonth(reference.getMonth());
        }
        if( reference.getFullYear() !== diff.getFullYear() ){
            diff.setFullYear(reference.getFullYear());
        }
        diff.setDate(reference.getDate() + difference);
        return diff;
    };

    var plotFbEvents = function(eventsCache){
        $scope.popUp.interviewers = [];
        $scope.freebusy.options.resources = [];
        angular.forEach(eventsCache,function(evt){
            if(evt.interviewers){
               angular.forEach(evt.interviewers,function(user){
                    var fbuser = angular.copy(user);
                    $scope.popUp.interviewers.push(fbuser);
               });
            }

        });

    };

    /**
     * Collects all interviewers present in all the events currently scheduled.
     */

    var allIntrvrsinEvents = function(){
        var allIntrvrs = {};
        scheduler.clientEvents(function(event){
            if(!event.interviewers){
                return;
            }
            angular.forEach(event.interviewers, function(interviewer){
                if(!allIntrvrs[interviewer.EId]){
                    allIntrvrs[interviewer.EId] = interviewer;
                }
            });
        });
        return allIntrvrs;
    };

    $scope.addLoading = function(name){
        name = name || 'default';
        if($scope.loading.indexOf(name) < 0){
            $scope.loading.push(name);
        }
        if(!$scope.flags.loading){
            $scope.flags.loading = true;
        }
    };

    $scope.removeLoading = function(name){
        if($scope.loading.length){
            if($scope.loading.indexOf(name) > -1){
                $scope.loading.splice($scope.loading.indexOf(name), 1);
            }
            if($scope.flags.loading && $scope.loading.length === 0){
                $scope.flags.loading = false;
            }
        }
    };

    /**   Things done on startup
     */

    $scope.setDisplayTimezone = function(){
        var firstCity = $scope.timeZone.name.match(/\)\s([\w\s]*\w)[-+,( ]{0,1}/) || [];
        if (firstCity.length < 2) {
            firstCity = '';
        } else {
            firstCity = firstCity[1];
        }
        $scope.timeZone.firstCity = firstCity;
        $scope.timeZone.title = $scope.getTimeZoneName($scope.timeZone.name);
    };

    // Displaying the loading indicator
    $scope.addLoading('candidates.interviewLocations');

    // Fetching all interview locations
    candidates.interviewLocations($routeParams.applicationId, $routeParams.stateId,$routeParams.groupId, function(data){
        //Reset locations and interviewer list which will be shown at schedule interview left side panel

        if($scope.mode === 'schedule'){
            $scope.$parent.interviewers = {};
            $scope.$parent.selLocations = {};
        }
        // TODO: Sanity checking
        $scope.timeZone = data.interviewSchedule.model.timezoneInfo;
        $scope.videoConferencingProperties.videoConferenceEnabled = data.interviewSchedule.model.videoConferenceEnabled;

        candidates.setUserTimezoneObject(data.interviewSchedule.model.timezoneInfo);
        if(!$scope.$parent.selectedTimezoneObj || !$scope.$parent.selectedTimezoneObj.openSysId){
            if(data.interviewSchedule.model.interviewTimezone){
                $scope.selectedTimezoneObj = data.interviewSchedule.model.interviewTimezone;
                $scope.timeZone = data.interviewSchedule.model.interviewTimezone;
                tz = $scope.selectedTimezoneObj.openSysId;
            }else if (data.interviewSchedule.model.timezoneInfo){
                $scope.selectedTimezoneObj = $filter('filter')(data.allTimezones, {'openSysId': data.interviewSchedule.model.timezoneInfo.openSysId})[0];
                $scope.timeZone = angular.copy($scope.selectedTimezoneObj);
                $scope.selectedTimezone = JSON.stringify($scope.selectedTimezoneObj);
            }
        }else{
            $scope.selectedTimezoneObj = $scope.$parent.selectedTimezoneObj;
            $scope.timeZone = $scope.$parent.selectedTimezoneObj;
            $scope.selectedTimezone = JSON.stringify($scope.$parent.selectedTimezoneObj);
        }
        $scope.allTimezones = data.allTimezones;
        $scope.allTimezones.unshift(null);

        $scope.setDisplayTimezone();

        if($scope.$parent.videoConferencingProperties) {
            $scope.videoConferencingProperties.includeConferenceLink = $scope.$parent.videoConferencingProperties.includeConferenceLink;
        }

        var locations = data.interviewSchedule.workflowElementInfo.metaModel.interviewLocation, resources={}, events = [], propName = 'ProfilePictureUrl', profilePicIds = [], userPropCache;
        locations = $filter('orderBy')(locations, 'name');
        angular.forEach(locations, function(location){
            location.EId = 'loc-'+ location.EId;//Creating a unique id for resource so that we can merge with freebusy of Users as UserId and ResourceId can be same
            $scope.allLocations[location.EId] = location;
            $scope.sortedLocations.push(location);
        });
        $scope.$parent.allLocations = $scope.allLocations;
        $scope.showLocations = !$.isEmptyObject($scope.allLocations);

        // Gcal verification
        $scope.$parent.gcalAuth = data.calendarInfo.hasGoogleCalendarSetup;
        if(data.calendarInfo.hasOwnProperty('googleCalendarAutorizationUrl')){
            $scope.$parent.gcalAuthUrl = data.calendarInfo.googleCalendarAutorizationUrl;
        }
        if(data.calendarInfo.hasOwnProperty('showGoogleCalendar')){
            $scope.$parent.gcalCompanySetup = data.calendarInfo.showGoogleCalendar;
        }
        if(data.calendarInfo.hasOwnProperty('showOutlookCalendarFreeBusy')){
            $scope.$parent.showOutlookCalendarFreebusy  = data.calendarInfo.showOutlookCalendarFreeBusy;
        }
        if(data.calendarInfo.hasOwnProperty('hasOffice365DelegateAccessEnabled')){
            $scope.$parent.hasOffice365DelegateAccessEnabled  = data.calendarInfo.hasOffice365DelegateAccessEnabled;
        }
        if(data.calendarInfo.hasOwnProperty('microsoftOfficeGraphIntegration')){
            $scope.$parent.microsoftOfficeGraphIntegration  = data.calendarInfo.microsoftOfficeGraphIntegration;
        }
        if(data.calendarInfo.hasOwnProperty('office365DelegateAuthUrl')){
         $scope.$parent.office365DelegateAuthUrl = data.calendarInfo.office365DelegateAuthUrl;
        }

        // Displaying events in the cache - when the user comes back to this page from Messager by clicking 'Back to scheduler'.
        // his piece of code is dependent on '$scope.allLocations', so exec in the callback.
        if($scope.$parent.reRenderEvents && !$.isEmptyObject($scope.eventsCache)){

            renderSchedEvents($scope.eventsCache);

            // Merge the below into renderSchedEvents(probably as a callback or something) - to avoid redundant looping.
            angular.forEach($scope.eventsCache, function(event){
                if($scope.mode === 'modifySchedule' && $scope.isGcalEnabled()){
                    angular.forEach(event.interviewers, function(interviewer, eid){
                        if(!resources[eid]){
                            $scope.freebusy.pushResource(interviewer, eid);
                            userPropCache = $scope.$parent.userPropsCache[eid];
                            if(!(interviewer.hasOwnProperty(propName)) ){
                                if(userPropCache && userPropCache[propName]){
                                    interviewer[propName] = userPropCache[propName];
                                }else{
                                    profilePicIds.push(eid);
                                }
                            }
                        }
                        // ToDo: WHy cant this go inside the if block?
                        resources[eid] = interviewer;
                    });
                    // Adding Loction to Free Busy Area while clicking 'Back to scheduler'
                    if(event.location && !resources[event.location] && $scope.allLocations[event.location]){
                        $scope.freebusy.pushResource($scope.allLocations[event.location], event.location);
                        resources[event.location] = $scope.allLocations[event.location];
                    }
                }
            });

            if($scope.isGcalEnabled()){
                if($scope.mode === 'schedule'){
                    $scope.freebusy.options.resources = $scope.$parent.fbResources;
                    angular.forEach($scope.freebusy.options.resources, function(resource){
                        if(!resource.hasOwnProperty('user')){
                            return; // Resource is not an interviewer but a location.
                        }
                        // ToDo: remove code dup(above for modifySchedule)
                        userPropCache = $scope.$parent.userPropsCache[resource.id];
                        if( !(resource.user.hasOwnProperty(propName)) ){
                            if(userPropCache && userPropCache[propName]){
                                resource.user[propName] = userPropCache[propName];
                            }else{
                                profilePicIds.push(resource.id);
                            }
                        }
                    });
                }
                angular.forEach($scope.freebusy.options.resources, function(resource){
                    angular.forEach($scope.eventsForResource(resource.id), function(event){
                        events.push($scope.freebusy.createFreeBusyEvent(event, resource.id));

                    });
                    if($scope.$parent.gcalEventsCache[resource.id]){
                        events = events.concat($scope.$parent.gcalEventsCache[resource.id]);
                    }
                });
                if(profilePicIds && profilePicIds.length){
                    /**
                     * SMK 04/08/14 comenting it for now as are moving the resource on admin and s3 . Also nothing form profile pic is being used today
                     */
                    // profilePicsForResources(profilePicIds, events);
                }else{
                    if(!$.isEmptyObject($scope.freebusy.options.resources)){
                        $scope.freebusy.options.events = events;
                        $scope.$broadcast($scope.FREEBUSY_NAMESPACE+'.refresh', $scope.freebusy.options);
                    }
                    if($scope.$parent.schedDate && !isToday($scope.$parent.schedDate)){
                        scheduler.gotoDate($scope.$parent.schedDate);
                    }
                }

            }
        }else{
            if($scope.mode === 'modifySchedule'){
                $scope.renderSchedules(data.interviewSchedule.model.durationInfo);
            }
        }
        //  Outlook Calendar Integration
        if($rootScope.isIE() && data.calendarInfo.showOutlookCalendar){
            /*use this to debug in chrome*/
            //if(data.calendarInfo.showOutlookCalendar){
            $scope.$parent.showOutlookCalender = true;
            $scope.outlookData = data.calendarInfo;
            $scope.checkActiveXInstall();
        }

        // Is this needed?
        /*if($scope.isGcalEnabled()){
        $scope.freebusy.init();
    }*/
        $scope.removeLoading('candidates.interviewLocations');
        $scope.reRenderCalender();

        if(data.interviewSchedule.model.candidateAvailability && data.interviewSchedule.model.candidateAvailability.selectedSlots){
            $scope.selfSchedule.candidateAvailability = data.interviewSchedule.model.candidateAvailability;
            showCandidateAvailability();

            if(data.interviewSchedule.model.availabilityRequest){
                $scope.selfSchedule.availabilityRequest = data.interviewSchedule.model.availabilityRequest;
                if($scope.selfSchedule.availabilityRequest.interviewers.length>0 && $scope.selfSchedule.availabilityRequest.interviewers[0].host && $scope.mode !== 'modifySchedule'){
                    $scope.videoConferencingProperties.includeConferenceLinkViaCSS = $scope.selfSchedule.availabilityRequest.interviewers[0].useVC;

                }else if($scope.selfSchedule.availabilityRequest.interviewers.length===0 && $scope.mode !== 'modifySchedule'){
                    $scope.videoConferencingProperties.includeConferenceLinkViaCSS = $scope.selfSchedule.availabilityRequest.useVC;
                }
                addInterviewersAndMeetingRooms();
            }
        }

        //plotFbEvents makes sure we add the interviewers from eventsCache back into the popup.interviewers array to trigger the watch : NV
        //This is the flow for when the user hits back to scheduler for both schedule and modify flows
        if($scope.eventsCache.length > 0){
            plotFbEvents($scope.eventsCache);
        }
    });

    // ToDo: Merge this with the profilePics method once Promise is implemented.
    var profilePicsForResources = function(userIds, events){ // eslint-disable-line
        var propName = 'ProfilePictureUrl';
        $scope.addLoading('candidates.propForUsers');
        candidates.propForUsers(propName, userIds , function(response){
            var userProps = {};
            angular.forEach(response.usersProperty, function(userProp){
                userProps[userProp.userEId] = userProp;
                $scope.$parent.userPropsCache[userProp.userEId] = $scope.userPropsCache[userProp.userEId] || {};
                $scope.$parent.userPropsCache[userProp.userEId][propName] = userProp.propertyValue;
            });
            angular.forEach($scope.freebusy.options.resources, function(resource){
                if(userProps[resource.id]){
                    resource.user[propName] = userProps[resource.id].propertyValue;
                }
            });
            if(!$.isEmptyObject($scope.freebusy.options.resources)){
                $scope.freebusy.options.events = events;
                $scope.$broadcast($scope.FREEBUSY_NAMESPACE+'.refresh', $scope.freebusy.options);
            }
            if($scope.$parent.schedDate && !isToday($scope.$parent.schedDate)){
                scheduler.gotoDate($scope.$parent.schedDate);
            }
            $scope.removeLoading('candidates.propForUsers');
        });
    };

    $scope.checkActiveXInstall = function(){
        try {
            new ActiveXObject('FJInterview.Interview'); // eslint-disable-line
            $scope.$parent.showOutlookCalender = true;
            $scope.$parent.setUpOutlook = false;
        } catch (ex) {
            $scope.$parent.showOutlookCalender = false;
            $scope.$parent.setUpOutlook = true;
        }
    };

    $scope.setupActivex = function(){
        var url = $scope.$root.jvUrls.forum+'/Hiring/OutlookScheduling.aspx';
        var newWindow = window.open(url,'name','height=500,width=500');
        //var newWindow = window.open(url,'name','height=500,width=500');
        if (window.focus) {
            newWindow.focus();
        }
        $scope.$parent.showOutlookCalender = true;
        $scope.$parent.setUpOutlook = false;
    };


    $scope.checkSchedule = function(){
        var intrvrEmails = [], allIntrvrs = {}, candName ='', interview ={};

        allIntrvrs = allIntrvrsinEvents();
        angular.forEach($scope.interviewers, function(interviewer, eid){
            if(!allIntrvrs[eid]){
                allIntrvrs[eid] = interviewer;
            }

        });

        angular.forEach(allIntrvrs, function(interviewer){
            intrvrEmails.push(interviewer.email);
        });
        intrvrEmails = intrvrEmails.join(';');

        var locations = [];
        angular.forEach($scope.selLocations, function(value){
            locations.push(value.email);
        });
        locations = locations.join(';');

        candName = $scope.$parent.appDetails.application.candidate.firstName + $scope.$parent.appDetails.application.candidate.lastName;
        interview = new ActiveXObject('FJInterview.Interview'); // eslint-disable-line
        interview.Schedule3('', '', 0, '', 0, '', 0, candName, '', intrvrEmails, 'Checking Schedule', locations, $scope.outlookData);
    };


    //this menthod is used both checking google freebusy and outlookfreebusy
    $scope.isGcalEnabled = function(){
        return ($scope.gcalCompanySetup && $scope.gcalAuth) || $scope.showOutlookCalendarFreebusy || $scope.microsoftOfficeGraphIntegration || $scope.hasOffice365DelegateAccessEnabled;
    };

    $scope.showGcalConnect = function(){
        return ($scope.gcalCompanySetup && !$scope.gcalAuth && !$scope.showOutlookCalendarFreebusy) || (!$scope.microsoftOfficeGraphIntegration && $scope.hasOffice365DelegateAccessEnabled);
    };

    $scope.absUrl =  function(){
        return $location.absUrl();
    };

    /*
     * Removes properties that are not needed by the left interviewers panel.
     * During modify schedule if the left panel interviewers are populated from the ones in 'durationInfo, they contain extraneous properties on the interviewer like interviewStatus, interviewEId etc.
     * These properties cause issues when an interviewer is added to an event using D'n'D.
     */
    var filterInterviewer = function(interviewer){
        var intrvr = angular.copy(interviewer),
            allowedProps = {
                EId : true,
                email : true,
                firstName : true,
                fullName : true,
                lastName : true
            };

        angular.forEach(intrvr, function(value, name){
            if(!allowedProps[name]){
                delete intrvr[name];
            }
        });
        return intrvr;
    };

    $scope.renderSchedules = function(schedules){
        var schedEvents = [], resourceIds = {}, interviewerIds= {};// Favouring time over space by have 2 separate arrays(resIds and intrvIds)

        var tz = $window._jvselfUser.locale.timezone;
        if($scope.selectedTimezoneObj.openSysId){
            tz = $scope.selectedTimezoneObj.openSysId;
        }

        if(!schedules || $.isEmptyObject(schedules)){
            return;
        }

        angular.forEach(schedules, function(schedule){
            if(schedule.scheduleUtc){

                //var d = new Date(angular.copy(schedule.scheduleUtc));
                //var d = $filter('localeDateTime')(schedule.scheduleUtc, 'shortDate', 'MM/dd/yyyy');
                //schedule.scheduleUtc = d.getTime();
                //Backend is sending the time in milliseconds now
                schedule.fromDate = schedule.scheduleUtc;
                schedule.toDate = schedule.scheduleUtc +(schedule.duration*60*1000);
            }
            var event = emptyEvent();

            // Original schedule used for comparing changes if the event becomes dirty.
            event.original = schedule;
            event.original.intrvrsMap = {};

            //Making sure we parse the date in the users timezone
            //event.start = new Date(schedule.fromDate);
            event.start  = (moment.tz(schedule.fromDate, tz).format('YYYY-MM-DDTHH:mm:ss'));
            //event.start = event.start.toDate();

            //Making sure we parse the date in the users timezone
            //event.end = new Date(schedule.toDate);
            event.end = (moment.tz(schedule.toDate, tz).format('YYYY-MM-DDTHH:mm:ss'));
            //event.end = event.end.toDate();

            if($scope.videoConferencingProperties.videoConferenceEnabled && schedule.interviewers.length > 0){
                var hostEId = schedule.hostEId;
                if (!hostEId) {
                    // When interview was initially scheduled without video conferencing
                    hostEId = schedule.interviewers[0].userEId;
                }
                if (schedule.interviewers.length > 1) {
                    var hostIndex = -1;
                    for(var i=0; i<schedule.interviewers.length; i++){
                        if(schedule.interviewers[i].userEId === schedule.hostEId){
                            hostIndex = i;
                            break;
                        }
                    }

                    if(hostIndex > 0 && hostIndex < schedule.interviewers.length){
                        var hostObj = schedule.interviewers.splice(hostIndex, 1);
                        schedule.interviewers.unshift(hostObj[0]);
                    }
                }

                event.host = hostEId;
                event.originalHost = hostEId;
                event.useVC = schedule.useVC;
                event.meetingId = schedule.meetingId;
            }

            angular.forEach(schedule.interviewers, function(interviewer){
                interviewer.EId = interviewer.userEId;
                if(angular.isUndefined(interviewer.fullName)){
                    interviewer.fullName = '';
                    interviewer.fullName += interviewer.firstName || '';
                    interviewer.fullName += ' ';
                    interviewer.fullName += interviewer.lastName || '';
                }
                event.interviewers[interviewer.userEId] = angular.copy(interviewer);
                if(!$scope.$parent.interviewers[interviewer.EId]){
                    $scope.addInterviewer(filterInterviewer(interviewer), true);
                }
                event.original.intrvrsMap[interviewer.userEId] = interviewer;
                if(!resourceIds[interviewer.userEId]){
                    resourceIds[interviewer.userEId] = true;
                    $scope.freebusy.pushResource(interviewer, interviewer.EId);
                }
                interviewerIds[interviewer.userEId] = true;
            });
            if(schedule.locationEId){
                schedule.locationEId = 'loc-'+schedule.locationEId;// Making resourceId cosistant
                event.location = schedule.locationEId;
                if(!$scope.$parent.selLocations[schedule.locationEId]){
                    $scope.addLocation(schedule.locationEId, true);
                }
                if(!resourceIds[schedule.locationEId]){
                    resourceIds[schedule.locationEId] = true;
                    $scope.freebusy.pushResource($scope.allLocations[schedule.locationEId], schedule.locationEId);
                }
            }else if(schedule.location && !schedule.locationEId){
                var loc = {
                    name: schedule.location,
                    EId: '_'+tempLocCount
                };
                $scope.allLocations['_'+tempLocCount] = loc;
                event.location = '_'+tempLocCount;
                tempLocCount++;
            }else{
                // Makes it easy while comparing for reschedule in 'next'
                schedule.locationEId = '';
            }
            event.existing = true;
            schedEvents.push(event);
        });
        if(schedules[0]){
            $scope.videoConferencingProperties.includeConferenceLink = schedules[0].useVC;
        }
        /**
         * SMK 04/08/14 comenting it for now as are moving the resource on admin and s3 . Also nothing form profile pic is being used today
         */
//      profilePics(interviewerIds, resourceIds,  schedEvents);
//        Thie above code needs to be refactored properly
        profilePicsFixMe(interviewerIds, resourceIds,  schedEvents);
    };

    // Using a function as inline ng-click toggling did not work
    $scope.toggleSkipNavAway = function(){
        $scope.skipNavAway = true;
    };

    $scope.hasChanged = function(){
        if($scope.total > 1 || $scope.cancelledEvents.length){
            if($scope.skipNavAway){
                $scope.skipNavAway = false;
            }else{
                return i18n.SCHEDULER_NAV_AWAY_MESSAGE;
            }
        }
    };

    // Drawing the current time bar - Using an event that is 1 minute apart.
    later = new Date(now);
    later.setMinutes(now.getMinutes() + 1);

    $scope.$on($scope.SCHEDULER_NAMESPACE+'.created', function(ngEvent, calendar){
        scheduler = calendar;
        scheduler.fullCalendar('renderEvent', {start : now, end : later, title:'', allDay:false, editable:false, ignore:true, className:'static'}, true);
    });

    $scope.ismodifyModal = false;
    $scope.modifyModal = {
            show:false,
            buttons: [
                      {
                          label: i18n.EDIT_MESSAGE,
                          title: i18n.EDIT_MESSAGE,
                          click:  function(){
                              $scope.$parent.modify = true;
                              $scope.modifyModal.show=false;
                              // passing 'true' in case of 'modify only message' flow
                              $scope.next(true);
                              $scope.ismodifyModal = false;

                          }
                      },
                      {
                          label: i18n.CANCEL,
                          title: i18n.CANCEL,
                          click:  function(){
                              $scope.$parent.modify = false;
                              $scope.modifyModal.show=false;
                              $scope.ismodifyModal = false;
                          },
                          'class': 'cancel'
                      }
                      ],
                      title: i18n.SCHEDNOCHANGES,
                      body: i18n.SCHEDULE_NOCHANGES,
                      context : $scope,
                      cancel:function(){
                          $scope.$parent.modify = false;
                          $scope.modifyModal.show=false;
                      }
    };
    resetPopUp($scope.popUp);

 // Change the toggle class based on the toggle status
    $scope.calendarUI = {};
    $scope.calendarUI.toggleWidth = false;
    $scope.calendarUI.toggleClass = 'icon-panel-arrow';

    $scope.toggleCalendarView = function() {
            $scope.calendarUI.toggleWidth =! $scope.calendarUI.toggleWidth;

            if ( $scope.calendarUI.toggleWidth ) {
                    $scope.calendarUI.toggleClass = 'icon-panel-arrow-reverse';
            } else {
                    $scope.calendarUI.toggleClass = 'icon-panel-arrow';
            }
            $scope.reRenderCalender(200);
    };
    $scope.getTimeZoneName = function(timeZone){
        var title = timeZone.split(')');
        if(title && title.length>0){
            if(title[0].indexOf('UTC') > -1 || title[0].indexOf('GMT') > -1){
                title.shift();
            }
             title = title.join(')');
        }
        return title;
    };

    $scope.timezoneChange = function(timezone){
        if(!timezone && initTimezoneChange){
            initTimezoneChange = false;
        }else{
            if(!timezone){
                $scope.selectedTimezoneObj = {};
                tz = $window._jvselfUser.locale.timezone;
                $scope.timeZone = candidates.getUserTimezoneObject();
            }else{
                $scope.selectedTimezoneObj = JSON.parse(timezone);
                tz = $scope.selectedTimezoneObj.openSysId;
                $scope.timeZone = angular.copy($scope.selectedTimezoneObj);
            }

            $scope.setDisplayTimezone();

            if($scope.selfSchedule
                && $scope.selfSchedule.candidateAvailability
                && $scope.selfSchedule.candidateAvailability.selectedSlots ){
                showCandidateAvailability();
            }

            if($scope.freebusy && $scope.freebusy.calendar && $scope.isGcalEnabled()){
                var schedEvents = [];
                var resourceIds = angular.copy($scope.freebusy.getInterviewersInResource());
                $scope.gcalEventsCache = {};
                fetchGcalEvents(resourceIds, schedEvents);
            }
        }
    };
}

function FreeBusy($scope, candidates, $filter, $rootScope){


//    custom startDate and endDate for fetching free busy info
    var FREEBUSYSTARTDATE = -3;
    var FREEBUSYENDDATE = 13;

    // Private variables and methods
    var self = this;

    // This is instantiated from the freebusy directive.
    this.calendar;

    this.options = {
            header : {
                left: '',
                center: '',
                right: ''
            },
            editable:false,
            firstHour : 10,
            slotMinutes : 15,
            snapMinutes : 15,
            contentHeight : 722,
            eventBackgroundColor :'darkgray',
            allDaySlot: false,
            defaultView: 'resourceDay',
            resources: [],
            events: []
    };

    // TODO: Change name as it not just has intrvrs but also locatons
    var interviewersInResource = {};

    var removeEvents = function(resourceId){
        var resources = [], events;
        if(!self.calendar){
            return;
        }
        events = self.calendar.fullCalendar('clientEvents', function(event){
            return event.resourceId !== resourceId;
        });
        resources = jQuery.grep(self.options.resources, function (resource) { return resource.id !== resourceId; });
        self.options.events = events;
        self.options.resources = resources;
    };

    var normalizeColIndex = function(removedId, resources){
        var remColIndex;
        angular.forEach(resources, function(resource){
            if(resource.id === removedId){
                remColIndex = resource.user.colIndex;
            }
        });
        angular.forEach(resources, function(resource){
            if(resource.user.colIndex > remColIndex){
                resource.user.colIndex--;
            }
        });
        if($scope.intervColIndex > 0){
            $scope.intervColIndex --;
        }
    };

    // Public methods

    this.getInterviewersInResource = function(){
        return interviewersInResource;
    };

    this.isResourceRendered = function(resourceId){
        return interviewersInResource[resourceId];
    };

    this.pushResource = function(resource, eid){
        var userName;
        if(resource && resource.email){
            if(resource.hasOwnProperty('colIndex')){
                resource.colIndex = $scope.intervColIndex = (resource.colIndex > $scope.intervColIndex) ? resource.colIndex : $scope.intervColIndex;
            }else{
                resource.colIndex = $scope.intervColIndex++;
            }
            if(resource.hasOwnProperty('firstName')){
                userName = resource.firstName + ' ' + resource.lastName;
            }else{
                userName = resource.name;
            }
            self.options.resources.push({name: userName, id: eid, user: resource });
            interviewersInResource[eid] = true;
            if(resource.EId.indexOf('loc-') < 0){
                $scope.addInterviewer(resource, true);
            }
        }
    };

    var renderZeroMinuteEvents = function(eventList){
        /** Events with the same start and end time are modified to be rendered as 15 min event
            https://bugzilla.aws.jobvite.com/show_bug.cgi?id=19376: NV**/
            if(eventList && eventList.length > 0) {
                angular.forEach(eventList,function(event){
                var eventStartTime = new Date(event.start).getTime();
                var eventEndTime = new Date(event.end).getTime();
                var endDateObj, endDate, endMinute, endHour, endMonth, endYear;
                if(eventStartTime === eventEndTime){
                    endDateObj = new Date(event.end);
                    endDate = endDateObj.getDate();
                    endMinute = endDateObj.getMinutes();
                    //Adding 15minutes to the end time
                    endMinute = endMinute+15;
                    endHour = endDateObj.getHours();
                    endMonth = endDateObj.getMonth();
                    endYear = endDateObj.getFullYear();
                    event.end = new Date(endYear, endMonth, endDate, endHour, endMinute);
                    }
                });
            }
    };

    var renderResourceEvents = function(gcalEvents, users){
        var resourceEvents = [], fbEvents, tempEvents, usersLength = users.length;
        for(var i = 0; i < usersLength; i++){
            tempEvents = $scope.eventsForResource(users[i].EId);
            if(tempEvents && tempEvents.length){
                angular.forEach(tempEvents, function(event){ // eslint-disable-line
                    resourceEvents.push($scope.freebusy.createFreeBusyEvent(event, users[i].EId));
                });
            }
        }

        if(gcalEvents && gcalEvents.length){
            resourceEvents = resourceEvents.concat(gcalEvents);
        }
        //todo: check if it returns undefined
        if(self.calendar){
            fbEvents = self.calendar.fullCalendar('clientEvents');
        }
        if(fbEvents){
            self.options.events = resourceEvents.concat(fbEvents);
        }else{
            self.options.events = resourceEvents;
        }
        $scope.$broadcast($scope.FREEBUSY_NAMESPACE+'.refresh', self.options);
    };

    this.addResource = function(user){
        var gcalEvents;

        if(interviewersInResource[user.EId] || !user.email){
            return;
        }
        // TODO: make loading false on error cases.
        gcalEvents = $scope.gcalEventsCache[user.EId];
        if(gcalEvents && gcalEvents.length){
            self.pushResource(user, user.EId);
            renderResourceEvents(gcalEvents, [user]);
        }else{
            var chkUserId=user.EId;
            if(user.EId && user.EId.indexOf('loc-')>-1){
                chkUserId=user.EId.split('loc-')[1];
            }
            if(!(user.EId.indexOf('loc-')>-1)){
                $scope.addLoading('candidates.freeBusy');
                candidates.freeBusy(chkUserId, $rootScope.normalizeDates($scope.dateDiff(FREEBUSYSTARTDATE).getTime()), $rootScope.normalizeDates($scope.dateDiff(FREEBUSYENDDATE).getTime()),
                        $scope.selectedTimezoneObj.id, function(response){
                    self.pushResource(user, user.EId);
                    gcalEvents = self.createGCalEvents(response.freeBusyInfo);
                    renderZeroMinuteEvents(gcalEvents);
                    // Get any schedules events for this interviewer from the sceduler(ex: this resource could have been added and deleted from the panel)
                    renderResourceEvents(gcalEvents, [user]);
                    $scope.removeLoading('candidates.freeBusy');
                });
            }
            else{
                $scope.addLoading('candidates.freeBusyResource');
                candidates.freeBusyResource(chkUserId, $rootScope.normalizeDates($scope.dateDiff(FREEBUSYSTARTDATE).getTime()), $rootScope.normalizeDates($scope.dateDiff(FREEBUSYENDDATE).getTime()),
                        $scope.selectedTimezoneObj.id, function(response){
                    self.pushResource(user, user.EId);
                    gcalEvents = self.createGCalEvents(response.freeBusyInfo,true);
                    // Get any schedules events for this interviewer from the sceduler(ex: this resource could have been added and deleted from the panel)
                    renderResourceEvents(gcalEvents, [user]);
                    $scope.removeLoading('candidates.freeBusyResource');
                });
            }
        }
    };

    this.addResources = function(users){
        var gcalEvents = [], fetchEvents = [], fetchRes=[], serverGcalEvents;
        if(!users.length){
            return;
        }
        //clearing interviewersInResource to fetch free busy again in case the user hits back.
        if( ($scope.mode ==='modifySchedule' && $scope.popUp.mode !== 'edit') || ($scope.eventsCache.length && !$scope.$parent.reRenderEvents)){
            angular.forEach(users,function(user){
                interviewersInResource[user.EId] = false;
            });
        }

        for(var i = 0; i < users.length; i++){
            if(interviewersInResource[users[i].EId]){
                users.splice(i--,1);
            }else{

                self.pushResource(users[i], users[i].EId);
                // tempEvents = $scope.gcalEventsCache[users[i].EId];
                //if(tempEvents && tempEvents.length ){
                    //gcalEvents = gcalEvents.concat(tempEvents);
                //}else{
                    if(users[i].EId.indexOf('loc-')>-1){
                        $scope.pannelResouceloc[users[i].EId]=true;
                        fetchRes.push(users[i].EId.split('loc-')[1]);
                    }else{
                        fetchEvents.push(users[i].EId);
                    }
                //}
            }
        }

            if(fetchEvents && fetchEvents.length){
                $scope.addLoading('candidates.gCalEvents');
                candidates.gCalEvents($scope.serializeArray(fetchEvents, 'userId'), $rootScope.normalizeDates($scope.dateDiff(FREEBUSYSTARTDATE).getTime()) , $rootScope.normalizeDates($scope.dateDiff(FREEBUSYENDDATE).getTime()),
                        $scope.selectedTimezoneObj.id, function(response){
                    serverGcalEvents = $scope.freebusy.createGCalEvents(response.freeBusyInfo);
                    renderZeroMinuteEvents(serverGcalEvents);
                    if(angular.isArray(serverGcalEvents) && serverGcalEvents.length){
                        gcalEvents = gcalEvents.concat(serverGcalEvents);
                    }
                    /** Code smell: Use promise and chain them **/
                    renderResourceEvents(gcalEvents, users);
                    $scope.removeLoading('candidates.gCalEvents');
                });
            }
            if(fetchRes && fetchRes.length){
                $scope.addLoading('candidates.gCalEventsResource');
                candidates.gCalEventsResource($scope.serializeArray(fetchRes, 'locationId'), $rootScope.normalizeDates($scope.dateDiff(FREEBUSYSTARTDATE).getTime()) , $rootScope.normalizeDates($scope.dateDiff(FREEBUSYENDDATE).getTime()),
                        $scope.selectedTimezoneObj.id, function(response){
                    serverGcalEvents = $scope.freebusy.createGCalEvents(response.freeBusyInfo,true);
                    if(angular.isArray(serverGcalEvents) && serverGcalEvents.length){
                        gcalEvents = gcalEvents.concat(serverGcalEvents);
                    }
                    /** Code smell: Use promise and chain them **/
                    renderResourceEvents(gcalEvents, users);
                    $scope.removeLoading('candidates.gCalEventsResource');
                });
            }
        // }
    };

    /**
     * Converts server returnd Gcal events to fullcalendar compatible gcalevents
     */
    this.createGCalEvents = function(events, isResource){
        var event, gCalEvents=[];
        angular.forEach(events, function(userEvents, userEId){
            if(userEvents){
                for(var i = 0; i < userEvents.length; i++){
                    event = {allDay:false, title:'', resourceId: userEId, gcalEvent:true};
                    event.start = new Date(userEvents[i].fromDateString);
                    event.end = new Date(userEvents[i].toDateString);
                    if(isResource){
                        event.resourceId = 'loc-'+userEId;//Creating freebusy array with the unique id of resource and merged
                    }
                    gCalEvents.push(angular.copy(event));
                }
                if(!isResource){
                    $scope.$parent.gcalEventsCache[userEId] = gCalEvents;
                }
                else{
                    $scope.$parent.gcalEventsCache['loc-'+ userEId] = gCalEvents;
                }
            }
        });
        return gCalEvents;
    };

    this.removeResource = function(eid){
        if(!eid){
            return;
        }
        interviewersInResource[eid] = false;
        normalizeColIndex(eid, self.options.resources);
        removeEvents(eid);
        $scope.$broadcast($scope.FREEBUSY_NAMESPACE+'.refresh', self.options);
    };

    // ToDo; Remove dup methods - merge this with above
    this.removeResources = function(users){
        var usersLength = users.length;
        if(!usersLength){
            return;
        }
        for(var i = 0; i < usersLength; i++){
            interviewersInResource[users[i].EId] = false;
            normalizeColIndex(users[i].EId, self.options.resources);
            removeEvents(users[i].EId);
            $scope.removeInterviewer(users[i].EId);
        }
        $scope.$broadcast($scope.FREEBUSY_NAMESPACE+'.refresh', self.options);
    };

    this.replaceEvent = function(newEvent, user){
        // todo: remove. Temporary fix
        if(!self.calendar){
            return;
        }
        var events = self.calendar.fullCalendar('clientEvents');
        angular.forEach(events, function (event) {
            if(event.resourceId === user.EId && event.hasOwnProperty('origId') && newEvent._id === event.origId){
                event.start = newEvent.start;
                event.end = newEvent.end;
                self.calendar.fullCalendar('updateEvent', event);
            }
        });
    };

    this.addEvent = function(event, resourceId){
        if(!self.calendar){
            return;
        }
        self.calendar.fullCalendar('renderEvent', self.createFreeBusyEvent(event, resourceId), true);
    };

    this.createFreeBusyEvent = function(event, resourceId){
        var fbEvent = {};
        fbEvent = $scope.copyObj(event, ['start', 'end', 'allDay', 'title']);
        fbEvent.resourceId = resourceId;
        fbEvent.origId = event._id;
        return fbEvent;
    };

    // TODO: This could be done when the events are fetched the first time.
    this.gcalEvents = function(){
        var allEvents, gcalEvents = {};
        if(self.calendar){
            allEvents = self.calendar.fullCalendar('clientEvents');
            angular.forEach(allEvents, function(event){
                if(event.gcalEvent){
                    gcalEvents[event.resourceId] = gcalEvents[event.resourceId] || [];
                    gcalEvents[event.resourceId].push(event);
                }
            });
        }
        return gcalEvents;
    };


    // $scope methods
    // Remove dup code
    $scope.$on($scope.SCHEDULER_NAMESPACE + '.updateEvent', function(ngEvent, event, resourceIds){
        // Only if freebusy is already rendered.
        if(self.calendar){
            if(angular.isArray(resourceIds)){
                angular.forEach(resourceIds, function(resourceId){
                    self.addEvent(event, resourceId);
                });
            }else if(resourceIds){
                self.addEvent(event, resourceIds);
            }
        }
    });

    $scope.$on($scope.SCHEDULER_NAMESPACE + '.renderEvent', function(ngEvent, event, sticky, resourceIds){
        // Only if freebusy is already rendered.
        if(self.calendar){
            if(angular.isArray(resourceIds)){
                angular.forEach(resourceIds, function(resourceId){
                    self.addEvent(event, resourceId);
                });
            }else if(resourceIds){
                self.addEvent(event, resourceIds);
            }
        }
    });

    $scope.$on($scope.FREEBUSY_NAMESPACE+'.created', function(ngEvent, calendarObj){
        self.calendar = calendarObj;
    });

    $scope.$on($scope.SCHEDULER_NAMESPACE+'.removeEvents', function(ngEvent, removedEventId){
        // todo: remove. Temporary fix
        if(!self.calendar){
            return;
        }
        self.calendar.fullCalendar('removeEvents' , function(event){
            return event.origId === removedEventId;
        });
    });
}


if(!Object.keys) {
    Object.keys = function(o){
        if (o !== Object(o)) {
            throw new TypeError('Object.keys called on non-object');
        }
        var ret=[],p;
        for(p in o) {
            if(Object.prototype.hasOwnProperty.call(o,p)) {
                    ret.push(p);
                }

            }
        return ret;
    };
}

/**
 * Watch out for:
 * 1) Not doing angular.copy while pushin objects into cancelled, modifed etc
 * 2) Not copying id or _id while doing copyObj.
 *
 * */
